/* CHANGE LOG BY DEVESH 2026-10-29: stats "8 Lakh+" → real customer count (window.__sdCC.lakh). */
/* CHANGE LOG BY DEVESH 2026-10-17: Optional grouped extra carousel follows configured launch row; Comfort Edit Deal of the Day uses SDFCT, SDELPT and SDCS with Most Loved family cards. */
/* CHANGE LOG BY DEVESH 2026-10-07: products tagged ab-hide (A/B PDP copies, handle <original>-2) are skipped in this listing — they show on their own PDP only. */
/* New Color Launch engine — moved out of snippets/new-color-launch-js.liquid on 2026-10-01 so browsers cache it
   (was 159 KB inline in every page view). CHANGE LOG BY DEVESH 2026-10-01. Settings arrive via window.__nclCfg,
   written by the snippet just before this file loads. Edit JS HERE; settings wiring lives in the snippet. */
(function () {
  var C = window.__nclCfg || {};
  var SID    = C.sid;
  var TEMPLATE_SUFFIX = C.suffix;
  /* 2026-09-21: the Airy Linen Collection 2 launch offer is withdrawn — cards go back to the NEW LAUNCH
     pill and no Best Price strip, matching the first airy-linen template. The offer path below is kept
     intact; re-enable with `TEMPLATE_SUFFIX === 'airy-linen-collection-2'` if the offer returns. */
  var AIRY_LAUNCH_OFFER = false;
  var TOKEN  = '388bd37219d8ab7daee1c58a23c03cc8';
  var API    = 'https://' + C.shop + '/api/2025-10/graphql.json';
  var CHARTS = C.charts || {};
  var inr = new Intl.NumberFormat('en-IN', { maximumFractionDigits: 0 });
  var CAT_ORDER   = C.category_order;
  var ROUNDEL_FIT = C.roundel_fit;
  /* ── Gap Twill launch config ── */
  var LAUNCH_CODES = (C.launch_codes || '').split(',').map(function (s) { return s.trim().toUpperCase(); }).filter(Boolean);
  var SHOW_WIDE_LEG = C.show_wide_leg_trousers;
  var HIDE_WIDE_LEG = !SHOW_WIDE_LEG && heroOffGenderDefault(TEMPLATE_SUFFIX, window.location.search) === 'men';
  if (HIDE_WIDE_LEG) LAUNCH_CODES = LAUNCH_CODES.filter(function (code) { return code !== 'SDCWT'; });
  var LAUNCH_LABELS = {};
  (C.launch_labels || '').split('\n').forEach(function (ln) {
    var ci = ln.indexOf(':'); if (ci < 1) return;
    var lc = ln.slice(0, ci).trim().toUpperCase(), ll = ln.slice(ci + 1).trim();
    if (lc && ll) LAUNCH_LABELS[lc] = ll;
  });
  var CARD_CLICK = C.card_click || 'overview';   // 'overview' = quick-add modal, 'pdp' = straight to product page
  var PREORDER_LABEL = C.preorder_label || 'GET EARLY ACCESS';
  var SUPER_LABELS = { SMCTS: 'For Men' }; 
  /* launch price overrides — display only (Shopify prices untouched); slashed compare-at stays off the ORIGINAL price */
  var LAUNCH_PRICES = {};
  (C.launch_prices || '').split('\n').forEach(function (ln) {
    var ci = ln.indexOf(':'); if (ci < 1) return;
    var c = ln.slice(0, ci).trim().toUpperCase(), v = parseFloat(ln.slice(ci + 1).replace(/[^\d.]/g, ''));
    if (c && v > 0) LAUNCH_PRICES[c] = v;
  });
  function launchPriceFor(tagsLower) {
    for (var k in LAUNCH_PRICES) { if (tagsLower.indexOf(k.toLowerCase()) !== -1) return LAUNCH_PRICES[k]; }
    return 0;
  }
  var NEW_DAYS  = parseInt(C.new_days, 10) || 30;
  var NEW_LABEL = C.new_label || 'Happening Now';
  var TOP_LABEL = C.top_label || 'Top Rated';
  var SHOW_NEW  = C.show_new;
  var SHOW_TOP  = C.show_top;
  var TOP_RATED_TAGS = {"sdcp":1,"sdfsk":1,"sdawp":1,"sdasp":1,"sdafd":1,"sdlns":1,"sdask":1,"sdamk":1,"supfh":1,"suost":1,"sdvct":1,"sdbtj":1,"sdcs":1,"sdctd":1,"sdlht":1,"smflk":1,"smfsk":1,"smls":1,"smlhs":1,"smdpt":1,"smfrt":1,"smfct":1,"smcfs":1,"smanj":1,"smcts":1,"sdawc":1,"sdcwt":1};
  /* Price Drop = All Linen's Almost Gone pool: curated style-code tags + per-style colour allow-list */
  var DROP_TAGS = (C.drop_tags || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
  var DROP_ALLOWED = {};
  (C.drop_allowed || '').split('|').forEach(function (seg) {
    var ci = seg.indexOf(':'); if (ci < 0) return;
    var code = seg.slice(0, ci).trim().toLowerCase(); if (!code) return;
    var set = {};
    seg.slice(ci + 1).split(',').forEach(function (c) { c = c.trim().toLowerCase(); if (c) set[c] = 1; });
    DROP_ALLOWED[code] = set;
  });
  function styleCodeOf(p) {
    var tl = p.tags || [];
    for (var i = 0; i < tl.length; i++) { if (/^s[dmu][a-z0-9]{2,4}$/.test(tl[i])) return tl[i]; }   // {2,4} — 'summer25'-style campaign tags must NOT match
    return styleKeyOf(p);
  }
  function dropAllowed(p) {
    var set = DROP_ALLOWED[styleCodeOf(p)];
    if (!set) return true;
    return !!set[(p.colorName || '').trim().toLowerCase()];
  }
  function repsByStyle(list) {   // All Linen grouping: ONE card per style, colours diversified across the grid
    var by = {}, order = [];
    list.forEach(function (p) { var k = styleCodeOf(p); if (!by[k]) { by[k] = []; order.push(k); } by[k].push(p); });
    var usedCol = {};
    return order.map(function (k) {
      var arr = by[k];
      var pick = arr.filter(function (p) { return !usedCol[(p.colorName || '').trim().toLowerCase()]; })[0] || arr[0];
      usedCol[(pick.colorName || '').trim().toLowerCase()] = 1;
      return pick;
    });
  }
  var STATS_BN_D = C.stats_banner;
  var STATS_BN_M = C.stats_banner_mobile;
  var NEW_BN_M = C.new_banner;
  var NEW_BN_D = C.new_banner_desktop;
  var TOP_BN_M = C.top_banner;
  var TOP_BN_D = C.top_banner_desktop;
  var LAUNCH_BANNERS = C.launch_banners;

  function qs(s, c) { return (c || document).querySelector(s); }
  function qsa(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
  function id(suffix) { return document.getElementById(suffix + '-' + SID); }
  function slugify(s) { return (s || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '') || 'cat'; }
  function parseGids(val) { if (!val) return []; try { var a = JSON.parse(val); return Array.isArray(a) ? a : []; } catch (e) { return []; } }
  // category = product title minus gender prefix minus colour name (e.g. "Men Yellow Airy Linen Short Kurta" -> "Airy Linen Short Kurta")
  function deriveCatLabel(title, color) {
    var s = (title || '').replace(/\b(women's|men's|womens|mens|women|men|unisex)\b/gi, ' ');
    if (color) { var c = color.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); s = s.replace(new RegExp('\\b' + c + '\\b', 'i'), ' '); }
    return s.replace(/\s+/g, ' ').trim();
  }

  var sizeOrderMap = { 'XXS':1,'XS':2,'S':3,'M':4,'L':5,'XL':6,'2XL':7,'3XL':8,'4XL':9,'5XL':10 };

  var root = document.getElementById('saw-' + SID);
  var WOMEN_COLL = root.getAttribute('data-women-collection') || '';
  var MEN_COLL   = root.getAttribute('data-men-collection') || '';
  var WOMEN_TOP  = (root.getAttribute('data-women-top-tag')    || 'Women Topwear').toLowerCase().trim();
  var WOMEN_BOT  = (root.getAttribute('data-women-bottom-tag') || 'Women Bottomwear').toLowerCase().trim();
  var MEN_TOP    = (root.getAttribute('data-men-top-tag')      || 'Men Topwear').toLowerCase().trim();
  var MEN_BOT    = (root.getAttribute('data-men-bottom-tag')   || 'Men Bottomwear').toLowerCase().trim();
  var currentGender = 'women';
  var COLLECTION = '', TOP_TAG = '', BOT_TAG = '';
  function setGenderVars(g) {
    currentGender = (g === 'men') ? 'men' : 'women';
    if (currentGender === 'men') { COLLECTION = MEN_COLL; TOP_TAG = MEN_TOP; BOT_TAG = MEN_BOT; }
    else { COLLECTION = WOMEN_COLL; TOP_TAG = WOMEN_TOP; BOT_TAG = WOMEN_BOT; }
  }
  setGenderVars('women');
  var CAT_KEY    = root.getAttribute('data-cat-key') || 'category_filter_name';
  var IMG_KEY    = root.getAttribute('data-img-key') || 'category_filter_image';
  var CAT_SOURCE = root.getAttribute('data-cat-source') || 'metafield';
  var COMPARE_MULT = parseFloat(root.getAttribute('data-compare-mult')) || 2;
  var SHOW_TITLE = root.getAttribute('data-show-title') === 'true';
  var MAX        = parseInt(root.getAttribute('data-max'), 10) || 400;
  var STOCK_FILTER = root.getAttribute('data-stock-filter') === 'true';
  var MIN_INV    = parseInt(root.getAttribute('data-min-inv'), 10) || 15;
  var RATE       = 0.60;        // Step 1 (category gate): >= 60% of size SKUs must have qty > 0  (fixed in code — ignores saved setting)
  var COLOR_KEY  = root.getAttribute('data-color-key') || 'product_variants';
  var STEP2_AVG_MIN = 15;       // Step 2 (colour gate): a colour's average size qty must be > 15  (fixed in code)
  var SORT_BEST  = root.getAttribute('data-sort-best') !== 'false';   // rank categories by best sellers

  var roundelRow = document.getElementById('saw-roundel-row-' + SID);
  var gridEl     = document.getElementById('saw-grid-' + SID);
  var gthHeroKeep = null;
  var preWideLeg = HIDE_WIDE_LEG && qs('[data-pre-launch-code="SDCWT"]', gridEl);
  if (preWideLeg) preWideLeg.remove();

  var allProducts = {};      // handle -> product
  var categories  = [];      // { key, label, slug, image, hasTop, hasBottom, products[], roundelEl, rowEl, trackEl }
  var activeGroup = null;    // null | 'top' | 'bottom'
  var filterState = { size: null, colors: [], family: [], minPrice: 0, maxPrice: Infinity };
  var maxPriceLimit = 5000;
  var tempFilterSize = null;
  var tempFilterColors = [];
  var tempFilterFamily = [];
  var FAMILY_GROUPS = [['Black','#20211c'],['White','#e1ded7'],['Neutral','#c5b79c'],['Grey','#776b5b'],['Blue','#353c46'],['Green','#666f51'],['Yellow','#e2c05f'],['Pink','#cd7780'],['Maroon','#a12a2c'],['Brown','#54483e'],['Purple','#ccb498']];
  var tempFilterGroup = null;
  var qaSelectedVariantId = null;
  var qaCurrentProduct = null;
  var qaHideOffer = false;

  /* ───────── fetch whole collection (paginated) ───────── */
  var NODE_FIELDS = ' id title handle onlineStoreUrl totalInventory tags productType createdAt'
      + ' catName: metafield(namespace: "custom", key: "' + CAT_KEY + '") { value }'
      + ' catImg: metafield(namespace: "custom", key: "' + IMG_KEY + '") { value reference { ... on MediaImage { image { url } } } }'
      + ' colorMeta: metafield(namespace: "custom", key: "product_variant_name") { value }'
      + ' kiwiChart: metafield(namespace: "custom", key: "data_sizing_id_kiwi") { value }'
      + ' ratingMeta: metafield(namespace: "loox", key: "avg_rating") { value }'
      + ' ratersMeta: metafield(namespace: "loox", key: "num_reviews") { value }'
      + ' ownRating: metafield(namespace: "custom", key: "review_rating") { value } ownCount: metafield(namespace: "custom", key: "review_count") { value }'
      + ' specs: metafield(namespace: "custom", key: "product_specification") { reference { ... on Metaobject { k1: field(key: "ps_key_1") { value } v1: field(key: "ps_value_1") { value } k2: field(key: "ps_key_2") { value } v2: field(key: "ps_value_2") { value } k3: field(key: "ps_key_3") { value } v3: field(key: "ps_value_3") { value } k4: field(key: "ps_key_4") { value } v4: field(key: "ps_value_4") { value } k5: field(key: "ps_key_5") { value } v5: field(key: "ps_value_5") { value } k6: field(key: "ps_key_6") { value } v6: field(key: "ps_value_6") { value } } } }'
      + ' swatchMeta: metafield(namespace: "custom", key: "product_variant_value") { value }'
      + ' colorGroup: metafield(namespace: "custom", key: "' + COLOR_KEY + '") { value }'
      + ' images(first: 6) { edges { node { url(transform: {maxWidth: 440}) } } }'
      + ' plPrice: metafield(namespace: "custom", key: "prelaunch_price") { value } plCmp: metafield(namespace: "custom", key: "prelaunch_compare_at") { value } variants(first: 20) { edges { node { id price { amount } compareAtPrice { amount } availableForSale quantityAvailable sku selectedOptions { name value } } } }';
  function buildQuery(after, size) {
    var afterArg = after ? (', after: "' + after + '"') : '';
    var sortArg = SORT_BEST ? ', sortKey: BEST_SELLING' : '';
    return '{ collection(handle: "' + COLLECTION + '") { products(first: ' + (size || 100) + afterArg + sortArg + ') {'
      + ' pageInfo { hasNextPage endCursor }'
      + ' edges { node {' + NODE_FIELDS
      + ' } } } } }';
  }

  function gql(query) {
    return fetch(API, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': TOKEN },
      body: JSON.stringify({ query: query })
    }).then(function (r) { return r.json(); });
  }

  function fetchAll() {
    var raw = [];
    function page(after) {
      return gql(buildQuery(after)).then(function (j) {
        var coll = j && j.data && j.data.collection;
        if (!coll) return raw;
        var conn = coll.products;
        (conn.edges || []).forEach(function (e) { raw.push(e.node); });
        if (conn.pageInfo && conn.pageInfo.hasNextPage && raw.length < MAX) {
          return page(conn.pageInfo.endCursor);
        }
        return raw;
      });
    }
    return page(null).catch(function (err) { console.error('SAW fetch error', err); return raw; });
  }

  function resolveCatImage(node) {
    if (node.catImg) {
      if (node.catImg.reference && node.catImg.reference.image && node.catImg.reference.image.url) return node.catImg.reference.image.url;
      var v = node.catImg.value || '';
      if (/^https?:\/\//.test(v)) return v;
    }
    return '';
  }

  function normalize(p, isLaunch) {
    // No stock-based early return — every colour flows through so Step 1 can count all of a
    // category's size SKUs. Stock filtering happens later, in sequence (Step 1 -> Step 2).
    var edges = p.variants.edges || [];
    var v = (edges.find(function (e) { return e.node.quantityAvailable > 0; }) || {}).node || (edges[0] || {}).node;
    var basePrice = parseFloat((v && v.price && v.price.amount) || 0);
    var cmpRaw    = parseFloat((v && v.compareAtPrice && v.compareAtPrice.amount) || 0);
    /* 2026-08-29: metafield-driven pre-launch display price (Lister tool) — mirrors
       sections/new-collection-page.liquid. Display only; cart still charges the real price. */
    var plv = p.plPrice ? parseFloat(p.plPrice.value) : 0;
    if (plv > 0) {
      basePrice = plv;
      var plc = p.plCmp ? parseFloat(p.plCmp.value) : 0;
      cmpRaw = plc > plv ? plc : 0;
    }
    var compare   = cmpRaw > basePrice ? cmpRaw : basePrice * COMPARE_MULT;

    var ovr = launchPriceFor((p.tags || []).map(function (t) { return t.toLowerCase().trim(); }));
    if (ovr > 0 && ovr < basePrice) basePrice = ovr;   // compare already fixed above → slashed price unchanged

    var allImages = p.images.edges.map(function (e) { return e.node.url; });
    var colorVal  = (p.colorMeta && p.colorMeta.value) ? p.colorMeta.value.trim() : '';
    var swatchVal = (p.swatchMeta && p.swatchMeta.value) ? p.swatchMeta.value.trim().replace(/[;"']/g, '') : '';  // e.g. "rgb(102,111,81)" or "#3f5a2e"
    var rawColor  = colorVal || p.title;
    var tagsLower = (p.tags || []).map(function (t) { return t.toLowerCase().trim(); });

    var mapped = edges.map(function (e) {
      var sizeOpt = e.node.selectedOptions.find(function (o) { return o.name.toLowerCase() === 'size'; });
      return {
        id: e.node.id.split('/').pop(),
        size: sizeOpt ? sizeOpt.value : 'Default',
        available: isLaunch ? (e.node.availableForSale !== false) : (e.node.quantityAvailable > 0),
        qty: e.node.quantityAvailable || 0,
        price: parseFloat(e.node.price.amount)
      };
    });
    var sizes = [];
    mapped.forEach(function (m) { if (m.available && m.size !== 'Default' && sizes.indexOf(m.size) === -1) sizes.push(m.size); });
    sizes.sort(function (a, b) { return (sizeOrderMap[a] || 99) - (sizeOrderMap[b] || 99); });
    // ── per-colour SKU stats — filtering happens later, in sequence (no early return here) ──
    var sizeVars  = mapped.filter(function (m) { return m.size !== 'Default'; });
    var countVars = sizeVars.length ? sizeVars : mapped;             // one-size products counted on their single variant
    var skuCount  = countVars.length;                                // total size SKUs for this colour
    var skuGt0    = countVars.filter(function (m) { return m.qty > 0; }).length;          // Step 1 metric: SKUs with stock (qty > 0)
    var sumQty    = countVars.reduce(function (a, m) { return a + (m.qty || 0); }, 0);
    var avgQty    = skuCount > 0 ? (sumQty / skuCount) : 0;          // Step 2 metric: average units across this colour's size SKUs

    var fromMeta  = (p.catName && p.catName.value) ? p.catName.value.trim() : '';
    var fromTitle = deriveCatLabel(p.title, colorVal);
    var catLabel  = (CAT_SOURCE === 'title' ? (fromTitle || fromMeta) : (fromMeta || fromTitle)) || (p.productType && p.productType.trim()) || 'Other';

    return {
      title: p.title, colorName: rawColor, swatch: swatchVal, handle: p.handle, isLaunch: !!isLaunch, createdAt: p.createdAt || '',
      link: '/products/' + p.handle,
      image: allImages[0] || '', images: allImages,
      price: basePrice, compare: compare,
      tags: tagsLower, sizes: sizes, variants: mapped,
      kiwiId: (p.kiwiChart && p.kiwiChart.value) ? p.kiwiChart.value.trim() : '',
      specs: (p.specs && p.specs.reference) || null,
      /* the product's OWN numbers first (custom.review_rating/_count, like saw3) — loox.* repeats the family total on every colour */
      rating: (p.ownRating && p.ownRating.value) || (p.ratingMeta && p.ratingMeta.value) || '',
      raters: (p.ownCount && p.ownCount.value) || (p.ratersMeta && p.ratersMeta.value) || '',
      famRating: (p.ratingMeta && p.ratingMeta.value) || '', famRaters: (p.ratersMeta && p.ratersMeta.value) || '',
      catLabel: catLabel, catImage: resolveCatImage(p),
      gid: p.id, siblingGids: parseGids(p.colorGroup && p.colorGroup.value), totalInv: p.totalInventory || 0,
      skuCount: skuCount, skuGt0: skuGt0, avgQty: avgQty,
      isTop: tagsLower.indexOf(TOP_TAG) !== -1,
      isBottom: tagsLower.indexOf(BOT_TAG) !== -1,
      displaySize: sizes.length > 1 ? (sizes[0] + ' - ' + sizes[sizes.length - 1]) : (sizes[0] || ''),
      colorCode: (((edges[0] || {}).node || {}).sku || '').split('_')[0].toUpperCase()
    };
  }

  function normalizeList(nodes) {
    nodes = nodes.filter(function (n) { return (n.tags || []).indexOf('ab-hide') === -1; });   /* ab-hide: A/B copy, own PDP only */
    var out = [];
    nodes.forEach(function (n, i) { var p = normalize(n); if (p) { p.rank = i; out.push(p); } });
    return out;   // rank = position in the collection's BEST_SELLING order
  }
  var NEW_SET = {}; (C.new_codes || '').split(',').forEach(function (s, i) { s = s.trim().toUpperCase(); if (s) NEW_SET[s] = i; });
  var NEW_BADGE = C.new_badge || 'NEW COLOR';
  var VIEW_ALL = {}; (C.view_all_links || '').split('\n').forEach(function (l) { var i = l.indexOf(':'); if (i > 0) VIEW_ALL[l.slice(0, i).trim().toUpperCase()] = l.slice(i + 1).trim(); });
  function normalizeLaunchList(nodes) {
    nodes = nodes.filter(function (n) { return (n.tags || []).indexOf('ab-hide') === -1; });   /* ab-hide: A/B copy, own PDP only */
    var out = [];
    nodes.forEach(function (n, i) {
      var p = normalize(n, true); if (!p) return;
      p.rank = i; p.launchCode = codeOf(p);
      if (!p.launchCode) return;   // only products carrying one of the launch style codes
      if (NEW_SET[p.colorCode] != null) {
        /* new colour: shown even at 0 stock (owner, 2026-10-01) — sizes from every variant, not just available ones */
        p.isNewColor = true; p.newIdx = NEW_SET[p.colorCode];
        var all = []; (p.variants || []).forEach(function (m) { if (m.size !== 'Default' && all.indexOf(m.size) === -1) all.push(m.size); });
        all.sort(function (a, b) { return (sizeOrderMap[a] || 99) - (sizeOrderMap[b] || 99); });
        p.sizes = all; p.displaySize = all.length > 1 ? (all[0] + ' - ' + all[all.length - 1]) : (all[0] || '');
      } else {
        p.isLaunch = false;                          // existing colour: standard card, in stock only
        if (!((p.totalInv || 0) > 0)) return;
      }
      out.push(p);
    });
    return out;
  }
  /* ── GAP TWILL LAUNCH helpers ── */
  var EXTRA_CODES = (C.extra_codes || '').split(',').map(function (s) { return s.trim().toUpperCase(); }).filter(Boolean);
  var EXTRA_LABEL = C.extra_label || 'Twill Trousers';
  var EXTRA_SUB = C.extra_sub || '';
  var HN_CAR = C.hn_carousel;
  var EXTRA_HEAD = (function () { var s = C.extra_heading || ''; if (!s) return '';
    if (s === 'none') return 'none';
    var i = s.indexOf('|'); return i < 0 ? esc2(s) : esc2(s.slice(0, i)) + '<i>' + esc2(s.slice(i + 1)) + '</i>'; })();
  function esc2(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;'); }
  var EXTRA_SET = {}; EXTRA_CODES.forEach(function (c) { EXTRA_SET[c] = 1; });
  var ALL_CODES = LAUNCH_CODES.concat(EXTRA_CODES);
  function codeOf(p) {
    var tl = p.tags || [];
    for (var i = 0; i < ALL_CODES.length; i++) { if (tl.indexOf(ALL_CODES[i].toLowerCase()) !== -1) return ALL_CODES[i]; }
    return null;
  }
  function codeGender(code) { return /^SD/i.test(code || '') ? 'women' : 'men'; }   // SD* = women, SM*/SU* = men (saadaa style-code convention)
  /* ?category=<slug> deep links — same contract as the shop-all pages (punctuation-insensitive) */
  function normCat(v) { return String(v || '').toLowerCase().replace(/[^a-z0-9]/g, ''); }
  var URL_CAT = (function () { try { return normCat(new URLSearchParams(location.search).get('category')); } catch (e) { return ''; } })();
  function urlCatGender() {   // a deep link to a launch family also decides the gender tab
    if (!URL_CAT) return null;
    for (var i = 0; i < LAUNCH_CODES.length; i++) {
      var c = LAUNCH_CODES[i], lbl = LAUNCH_LABELS[c] || '';
      if (normCat(lbl) === URL_CAT || normCat(c) === URL_CAT) return codeGender(c);
    }
    return null;
  }
  var MONTH_IDX = { jan: 0, feb: 1, mar: 2, apr: 3, may: 4, jun: 5, jul: 6, aug: 7, sep: 8, oct: 9, nov: 10, dec: 11 };
  function launchDateOf(p) {   // "<D Month YYYY> - New Launch" tag → Date (All Linen convention)
    var tg = p.tags || [];
    for (var i = 0; i < tg.length; i++) {
      var m = /^(\d{1,2})\s+([a-z]+)\s+(\d{4})\s*-\s*new\s*launch$/.exec(tg[i]);
      if (m) { var mo = MONTH_IDX[m[2].slice(0, 3)]; if (mo != null) return new Date(+m[3], mo, +m[1]); }
    }
    return null;
  }
  function isNewArrival(p) {
    var d = launchDateOf(p);
    if (d) { var age = Date.now() - d.getTime(); if (age >= 0 && age <= NEW_DAYS * 86400000) return true; }
    if (p.createdAt) { var c = new Date(p.createdAt).getTime(); if (!isNaN(c) && Date.now() - c <= NEW_DAYS * 86400000) return true; }
    return false;
  }
  function isTopRated(p) {
    return (p.tags || []).some(function (t) { return TOP_RATED_TAGS[t]; });
  }
  /** Top Rated membership as the page will actually render it — classification when we have one. */
  function inTopRated(p) {
    var t = sawTabsFor(currentGender);
    return sawTabsUsable(t) ? !!t.top[p.handle] : isTopRated(p);
  }
  function sortCategories() {
    var order = (CAT_ORDER || '').split('\n').map(function (s) { return s.trim().toLowerCase(); }).filter(Boolean);
    function pinned(cat) { var i = order.indexOf((cat.label || '').toLowerCase()); return i === -1 ? 9999 : i; }
    // best seller of the category, counting ONLY colours that survived the stock gates
    function bestRank(cat) {
      var best = Infinity;
      (cat.products || []).forEach(function (p) { if (typeof p.rank === 'number' && p.rank < best) best = p.rank; });
      return best;
    }
    categories.forEach(function (cat) { cat.bestRank = bestRank(cat); });
    categories.sort(function (a, b) {
      var pa = pinned(a), pb = pinned(b);
      if (pa !== pb) return pa - pb;                            // 1. explicit Category order wins
      if (SORT_BEST && a.bestRank !== b.bestRank) return a.bestRank - b.bestRank;   // 2. best seller in stock
      return b.products.length - a.products.length;             // 3. colour depth
    });
  }
  function buildCategories(prods) {
    allProducts = {};
    var map = {};
    prods.forEach(function (p) {
      allProducts[p.handle] = p;
      var slug = slugify(p.catLabel);
      if (!map[slug]) map[slug] = { key: p.catLabel, label: p.catLabel, slug: slug, image: '', group: null, hasTop: false, hasBottom: false, topCount: 0, botCount: 0, products: [] };
      var cat = map[slug];
      cat.products.push(p);
      if (p.isTop) cat.topCount++;
      if (p.isBottom) cat.botCount++;
      if (!cat.metaImage) cat.metaImage = p.catImage || '';
    });
    var regular = Object.keys(map).map(function (k) { return map[k]; });
    var ALL_COL = C.show_all_colours;
    if (!ALL_COL) {
      regular.forEach(function (cat) {
        cat.products = cat.products.filter(function (p) { return (p.skuCount || 0) > 0 && (p.skuGt0 / p.skuCount) >= RATE; });
      });
      regular.forEach(function (cat) {
        cat.products = cat.products.filter(function (p) { return (p.avgQty || 0) > STEP2_AVG_MIN; });
      });
    }
    regular = regular.filter(function (cat) { return cat.products.length > 0; });
    var pool = [];
    regular.forEach(function (cat) { pool = pool.concat(cat.products); });

    // 1. launch categories — pinned first, in LAUNCH_CODES order, one per style code, current gender only
    var launchCats = [], byCode = {}, extraCat = null;
    (launchPool || []).forEach(function (p) {
      if (!p.launchCode) return;
      if (codeGender(p.launchCode) !== currentGender) return;
      if (EXTRA_SET[p.launchCode]) {
        p.isLaunch = false;
        if (!extraCat) extraCat = { key: EXTRA_LABEL, label: EXTRA_LABEL, slug: slugify(EXTRA_LABEL), image: '', group: null, hasTop: false, hasBottom: false, topCount: 0, botCount: 0, products: [], carousel: true, grouped: !!C.extra_grouped, head: EXTRA_HEAD, sub: EXTRA_SUB };
        extraCat.products.push(p); allProducts[p.handle] = p;
        if (!extraCat.metaImage) extraCat.metaImage = p.catImage || '';
        return;
      }   // 2026-08-10: tiles + blocks follow the gender toggle (was: both genders on every tab)
      allProducts[p.handle] = p;
      var c = byCode[p.launchCode];
      if (!c) {
        var lbl = LAUNCH_LABELS[p.launchCode] || deriveCatLabel(p.title, p.colorName);
        c = byCode[p.launchCode] = { key: lbl, code: p.launchCode, label: lbl, slug: slugify(lbl), image: '', group: null, hasTop: false, hasBottom: false, topCount: 0, botCount: 0, products: [], isLaunch: true };
      }
      c.products.push(p);
      if (!c.metaImage) c.metaImage = p.catImage || '';
    });
    var LAUNCH_CAR = C.launch_carousel;
    LAUNCH_CODES.forEach(function (code) {
  if (pick3Products[code] && byCode[code]) {
    byCode[code].products.push(pick3Products[code]);
    allProducts[pick3Products[code].handle] = pick3Products[code];
  }
  if (byCode[code]) byCode[code].products.sort(function (a, b) { var an = a.isNewColor ? 0 : 1, bn = b.isNewColor ? 0 : 1; if (an !== bn) return an - bn; return an ? (a.rank || 0) - (b.rank || 0) : a.newIdx - b.newIdx; });
  if (byCode[code] && byCode[code].products.length) { if (LAUNCH_CAR) byCode[code].carousel = true; launchCats.push(byCode[code]); }
});
    /* families (tiles + rows) by best seller: a family's rank = its best-selling colour (owner, 2026-10-01) */
    launchCats.forEach(function (c) { c._best = 9e8; c.products.forEach(function (p) { if (!p.isNewColor && typeof p.rank === 'number' && p.rank < c._best) c._best = p.rank; }); });
    launchCats.sort(function (a, b) { return a._best - b._best; });
    var used = {};
    launchCats.forEach(function (c) { c.products.forEach(function (p) { used[p.handle] = 1; }); });
    if (extraCat) {
      extraCat.products.forEach(function (p) { used[p.handle] = 1; });
      var bestBy = {};
      extraCat.products.forEach(function (p) { var k = p.launchCode; if (!bestBy[k] || (p.totalInv || 0) > (bestBy[k].totalInv || 0)) bestBy[k] = p; });
      if (extraCat.grouped) {
        var groupedReps = repsByStyle(extraCat.products.slice().sort(function (a, b) { return a.rank - b.rank; }));
        extraCat.products = EXTRA_CODES.map(function (code) { return groupedReps.filter(function (p) { return p.launchCode === code; })[0]; }).filter(Boolean);
      } else {
        extraCat.products = EXTRA_CODES.map(function (c) { return bestBy[c]; }).filter(Boolean);
      }
    }
    var EXCL = (C.exclude_cats || '').toLowerCase().split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    regular.forEach(function (c) {
      c.products = c.products.filter(function (p) { return !used[p.handle] && !codeOf(p); });   // launch families live only in their own rows (men's SMANJ leaked into Women)
      c.carousel = true;
      var m = 9e8; c.products.forEach(function (p) { var r = p.rank || 9e8; if (r < m) m = r; });
      c._rk = m;
    });
    regular = regular.filter(function (c) { return c.products.length && EXCL.indexOf(c.slug) === -1 && EXCL.indexOf(c.label.toLowerCase()) === -1; });
    regular.sort(function (a, b) { return a._rk - b._rk; });

    var tpx = topPools[currentGender];
    mlPool = (tpx && tpx.length) ? tpx : pool;   // Most Loved colour slide looks up family colours here
    if (tpx && tpx.length) pool = tpx.filter(function (p) { return !used[p.handle]; });
    // 2. Happening Now — catalogue products with a recent "<D Month YYYY> - New Launch" tag
    var hn = SHOW_NEW ? pool.filter(function (p) { return !used[p.handle] && isNewArrival(p) && !inTopRated(p); }) : [];   // launch rows + Top Rated own their products
    hn.sort(function (a, b) { return launchDateOf(b) - launchDateOf(a); });
    if (HN_CAR) hn = repsByStyle(hn);   // grouped like the extra row — one card per style
    hn = hn.slice(0, 12);
    hn.forEach(function (p) { used[p.handle] = 1; });

    // 3. The three tabs. Membership and order come from assets/saw-tabs.json; anything already
    //    rendered above is in `used`, so a product never appears twice on the page.
    /* 2026-10-01 (owner): the Top Rated zone's tabs are Similar Fabrics / Similar Styles / Pair It With, all from this
       gender's best-selling pool, in stock, one card per style, launch families left out (they own the rows above).
         Similar Fabrics = same "fabric - …" tag as the launch families on show (Airy Linen, Flowy Linen …)
         Similar Styles  = every kurta (tag kurtas / kurta)
         Pair It With    = every pant (tag pants) */
    var tabPool = (pool || []).filter(function (p) { return !used[p.handle] && LAUNCH_CODES.indexOf(codeOf(p)) === -1 && (p.totalInv || 0) > 0; });
    var launchFab = {};
    launchCats.forEach(function (c) { (c.products || []).forEach(function (p) { (p.tags || []).forEach(function (t) { if (t.indexOf('fabric - ') === 0) launchFab[t] = 1; }); }); });
    var hasTag = function (p, list) { return (p.tags || []).some(function (t) { return list.indexOf(t) !== -1; }); };
    /* 2026-10-15 (owner): a style family shows in ONE tab only. Each style (best-selling first) goes to whichever of
       its eligible tabs has the fewest styles so far — a fixed order left Similar Styles empty (every best-selling kurta
       is the launch fabric). */
    var isFab = function (p) { return (p.tags || []).some(function (t) { return launchFab[t]; }); };
    var isSty = function (p) { return hasTag(p, ['kurtas', 'kurta']); };
    var isPair = function (p) { return hasTag(p, ['pants']); };
    var tabOf = {}, tabN = { fab: 0, sty: 0, pair: 0 };
    if (SHOW_TOP) tabPool.forEach(function (p) {
      var k = styleCodeOf(p); if (tabOf[k]) return;
      var el = [['fab', isFab], ['sty', isSty], ['pair', isPair]].filter(function (e) { return e[1](p); }).map(function (e) { return e[0]; });
      if (!el.length) return;
      var best = el.reduce(function (a, b) { return tabN[b] < tabN[a] ? b : a; });
      tabOf[k] = best; tabN[best]++;
    });
    var inTab = function (key) { return function (p) { return tabOf[styleCodeOf(p)] === key; }; };
    var tabFab  = SHOW_TOP ? repsByStyle(tabPool.filter(inTab('fab'))) : [];
    var tabSty  = SHOW_TOP ? repsByStyle(tabPool.filter(inTab('sty'))) : [];
    var tabPair = SHOW_TOP ? repsByStyle(tabPool.filter(inTab('pair'))) : [];
    var tr = tabFab;

    categories = [];
    categories = categories.concat(launchCats).concat(regular);
    if (extraCat) {
      var extraAfter = String(C.extra_after_code || '').trim().toUpperCase();
      var extraIndex = categories.findIndex(function (cat) { return cat.code === extraAfter; });
      if (extraAfter && extraIndex >= 0) categories.splice(extraIndex + 1, 0, extraCat);
      else categories.push(extraCat);
    }
    if (hn.length) categories.push({ key: NEW_LABEL, label: NEW_LABEL, slug: 'happening-now', image: '', group: null, hasTop: false, hasBottom: false, topCount: 0, botCount: 0, products: hn, special: HN_CAR ? null : 'new', carousel: !!HN_CAR });
    if (coordProducts.length && (COORD_GENDER === 'both' || COORD_GENDER === currentGender)) {
      var coordCat = { key: COORD_LABEL, label: COORD_LABEL, slug: 'co-ords', image: '', group: null, hasTop: false, hasBottom: false, topCount: 0, botCount: 0, products: coordProducts.slice(), carousel: true, isCoord: true };
      if (COORD_IMAGE) coordCat.metaImage = COORD_IMAGE;
      coordProducts.forEach(function (p) { allProducts[p.handle] = p; used[p.handle] = 1; });
      categories.push(coordCat);
    }
    if (tabFab.length || tabSty.length || tabPair.length) categories.push({ key: TOP_LABEL, label: TOP_LABEL, slug: 'top-rated', image: '', group: null, hasTop: false, hasBottom: false, topCount: 0, botCount: 0, products: tabFab, styleProducts: tabSty, pairProducts: tabPair, special: 'top', mode: tabFab.length ? 'fab' : (tabSty.length ? 'sty' : 'pair') });
    if (URL_CAT) {   // ?category=<slug> leads the page
      var pinIdx = -1;
      for (var ci = 0; ci < categories.length; ci++) {
        if (normCat(categories[ci].slug) === URL_CAT || normCat(categories[ci].label) === URL_CAT) { pinIdx = ci; break; }
      }
      if (pinIdx > 0) categories.unshift(categories.splice(pinIdx, 1)[0]);
    }
    assignCatImages();     // tile images last — needs the final order to avoid repeating a colour
  }
  /* Tile images: a merchant-set category image always wins. Otherwise pick the first colour of the
     category that no earlier tile already used, so the row doesn't show three Rose Taupe tiles. */
  function assignCatImages() {
    var used = {};                                  // colour -> how many tiles already use it
    function colourKey(p) {
      var c = (p.colorName || '').toLowerCase().trim();
      // fold shade words together so "Jet Black" doesn't count as different from "Black"
      c = c.replace(/\b(jet|deep|dark|light|pale|bright|neon|classic|solid)\b/g, ' ').replace(/\s+/g, ' ').trim();
      return c;
    }
    categories.forEach(function (cat) {
      if (cat.hideRoundel) return;
      if (cat.metaImage) { cat.image = cat.metaImage; return; }
      if (cat.slug === 'top-rated' || cat.slug === 'happening-now') {
        var opp = currentGender === 'men' ? 'women' : 'men';
        var gp = cat.products.filter(function (p) { var t = p.tags || []; return t.indexOf(currentGender) !== -1 && t.indexOf(opp) === -1; });
        if (gp.length) { cat.image = gp[0].image || ''; return; }
      }
      var pick = null, pickKey = '', best = Infinity;
      for (var i = 0; i < cat.products.length; i++) {
        var k = colourKey(cat.products[i]);
        var n = k ? (used[k] || 0) : 0;
        if (n === 0) { pick = cat.products[i]; pickKey = k; break; }   // unused colour → take it
        if (n < best) { best = n; pick = cat.products[i]; pickKey = k; }   // else remember the least-used
      }
      if (!pick) return;
      cat.image = pick.image || '';
      if (pickKey) used[pickKey] = (used[pickKey] || 0) + 1;
    });
  }
  // ── Step 1 (colour gate): a colour (product) shows only if >= RATE of its OWN size SKUs
  //    have stock (qty > 0). Evaluated per product, not per category.
  function applyStep1Colours() {
    categories.forEach(function (cat) {
      cat.products = cat.products.filter(function (p) {
        return (p.skuCount || 0) > 0 && (p.skuGt0 / p.skuCount) >= RATE;
      });
    });
  }
  // ── Step 2 (colour gate): within surviving categories, show a colour only if the AVERAGE
  //    units across all its size SKUs is greater than STEP2_AVG_MIN. Categories left empty are dropped.
  function applyStep2Colours() {
    categories.forEach(function (cat) {
      cat.products = cat.products.filter(function (p) { return (p.avgQty || 0) > STEP2_AVG_MIN; });
    });
    categories = categories.filter(function (cat) { return cat.products.length > 0; });
  }

  /* ───────── FOMO ───────── */
  function getFomo(title) {
    var now = new Date(), hour = now.getHours(), seed = 0;
    if (title) for (var i = 0; i < title.length; i++) seed += title.charCodeAt(i);
    var hs = now.getDate() + seed + hour;
    function rand(s) { var x = Math.sin(s) * 10000; return x - Math.floor(x); }
    var view, sold;
    if (hour >= 0 && hour < 7) { view = 250 + Math.floor(rand(hs) * 51); sold = 10 + Math.floor(rand(hs + 1) * 6); }
    else { var ha = hour - 7 + 1; view = 250 + (ha * 190) + Math.floor(rand(hs) * 150) - 75; if (view > 3500) view = 3500 - Math.floor(rand(hs) * 100); sold = 10 + (ha * 10) + Math.floor(rand(hs + 1) * 8) - 3; }
    return { view: view, sold: sold };
  }
  function startFomoLive() {
    if (window['sawFomoInt_' + SID]) clearInterval(window['sawFomoInt_' + SID]);
    window['sawFomoInt_' + SID] = setInterval(function () {
      qsa('.js-view-count', root).forEach(function (el) { var c = parseInt(el.innerText, 10); if (isNaN(c)) return; var n = c + (Math.floor(Math.random() * 11) - 4); if (n < 10) n = 10; el.innerText = n; });
      qsa('.js-sold-count', root).forEach(function (el) { var c = parseInt(el.innerText, 10); if (isNaN(c)) return; el.innerText = c + (Math.floor(Math.random() * 3) + 1); });
    }, 8500);
  }

  /* ───────── render roundels + row shells ───────── */
  /* 2026-08-28: Storefront gives master-size URLs (~1350px) for a ~272px box. Unsized, a full
     page of cards is GBs of decoded bitmap and iOS jetsam-kills the tab on scroll. */
  function cdnImg(url, w) {
    if (!url) return url;
    if (url.indexOf('cdn.shopify') === -1 && url.indexOf('/cdn/shop') === -1) return url;
    if (/[?&]width=/.test(url)) return url;
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
  }

  function squareImg(url) {
    if (!url || ROUNDEL_FIT !== 'cover') return url;
    var isShopifyCdn = url.indexOf('cdn.shopify') !== -1 || url.indexOf('/cdn/shop') !== -1;
    if (!isShopifyCdn) return url;
    // 3:4 to match the tile box, cropped from the top so the model's head survives.
    // (Was 220x220 crop=center — the CDN chopped the head off before CSS ever saw the image.)
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=360&height=480&crop=top';
  }
  var TILE_STRIP = C.tile_strip;
  function splitRoundelLabel(lbl) {   // "Cotton Pants" → Cotton <b>Pants</b>, matching All Linen
    lbl = String(lbl || '').trim();
    if (TILE_STRIP) {   // tile label only — the row heading keeps the full category name
      TILE_STRIP.split(',').forEach(function (w) {
        w = w.trim(); if (!w) return;
        lbl = lbl.replace(new RegExp(w.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '\\s*', 'ig'), '');
      });
      lbl = lbl.replace(/\s{2,}/g, ' ').trim();
    }
    var i = lbl.lastIndexOf(' ');
    if (i < 0) return '<b>' + esc(lbl) + '</b>';
    return esc(lbl.slice(0, i)) + ' <b>' + esc(lbl.slice(i + 1)) + '</b>';
  }
  /* 2026-10-01: top tiles → Shop All Women 4 pill toggles (assets/saw3.css .saw-ctog values). Label per family code
     from the pill_labels setting (CODE: Label), else the tile label. Still .saw-roundel underneath, so tap → scroll to
     the row and the scroll-spy active state work exactly as the tiles did. */
  var PILL_LABELS = {}; (C.pill_labels || '').split('\n').forEach(function (l) { var i = l.indexOf(':'); if (i > 0) PILL_LABELS[l.slice(0, i).trim().toUpperCase()] = l.slice(i + 1).trim(); });
  function pillImg(url) {
    if (!url) return url;
    if (url.indexOf('cdn.shopify') === -1 && url.indexOf('/cdn/shop') === -1) return url;
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=80&height=80&crop=top';
  }
  function roundelHtml(cat) {
    var lbl = (cat.code && PILL_LABELS[cat.code]) || String(cat.label || '').replace(/^(women|men)\s+/i, '');
    return '<label class="saw-roundel saw-ctog" data-cat="' + cat.slug + '" data-section="' + SID + '" data-top="' + cat.hasTop + '" data-bottom="' + cat.hasBottom + '" role="tab">'
      + (cat.image ? '<img class="saw-ctog-img" src="' + pillImg(cat.image) + '" alt="" width="30" height="30" decoding="async">' : '<span class="saw-ctog-img"></span>')
      + '<span class="saw-roundel-label">' + esc(lbl) + '</span></label>';
  }
  function roundelHtmlTile(cat) {   // pre-2026-10-01 square tile, kept for reference / quick revert
    var fit = ROUNDEL_FIT === 'contain' ? 'contain' : 'cover';
    var img = cat.image
      ? '<img class="saw-roundel-img" style="object-fit:' + fit + ';" src="' + squareImg(cat.image) + '" alt="' + cat.label.replace(/"/g, '&quot;') + '" loading="eager" fetchpriority="high" decoding="async">'
      : '<span class="saw-roundel-img"></span>';
    return '<label class="saw-roundel" data-cat="' + cat.slug + '" data-section="' + SID + '" data-top="' + cat.hasTop + '" data-bottom="' + cat.hasBottom + '" role="tab">'
      + '<span class="saw-roundel-img-wrap">' + img
      + (cat.slug === 'top-rated' ? '<span class="saw-tile-rate">4.5+ <i>\u2605</i></span>' : '')
      + (cat.isLaunch ? '<span class="saw-tile-new">NEW</span>' : '')
      + '<svg class="saw-roundel-check" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="3"><polyline points="20 6 9 17 4 12"/></svg></span>'
      + '<span class="saw-roundel-label">' + splitRoundelLabel(String(cat.label || '').replace(/^(women|men)\s+/i, '')) + '</span></label>';   // tiles drop the gender word (owner, 2026-10-01)
  }

  function bannerTitleHtml(mobile, desktop, label) {
    var html = '';
    if (mobile) html += '<img class="saw-gt-banner saw-gt-bn-m" src="' + mobile + '" alt="' + esc(label) + '" loading="lazy">';
    if (desktop) html += '<img class="saw-gt-banner saw-gt-bn-d" src="' + desktop + '" alt="' + esc(label) + '" loading="lazy">';
    return html + '<h2 class="saw-cat-title' + (mobile ? ' saw-title-hide-m' : '') + (desktop ? ' saw-title-hide-d' : '') + '">' + label + '</h2>';
  }
  /* Happening Now / Top Rated zones — All Linen pattern: full-width banner (or heading), mode tabs, stacked grid */
function zoneShellHtml(cat) {
    if (cat.carousel) {
      var chev = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><polyline points="{P}"/></svg>';
      var headHtml = cat.head === 'none' ? ''
        : cat.head ? '<div class="saw-copybreak"><h3>' + cat.head + '</h3>' + (cat.sub ? '<p>' + esc(cat.sub) + '</p>' : '') + '</div>'
        : '<div class="ncl-head"><h2 class="saw-cat-title">' + cat.label + '</h2>' + (cat.code && VIEW_ALL[cat.code] ? '<a class="ncl-viewall" href="/collections/' + esc(VIEW_ALL[cat.code]) + '">View All</a>' : '') + '</div>';
      return '<div id="saw-cat-' + cat.slug + '-' + SID + '" class="saw-cat ncl-rail' + (cat.isLaunch ? ' is-launch' : '') + '" data-cat="' + cat.slug + '" data-section="' + SID + '" data-top="' + cat.hasTop + '" data-bottom="' + cat.hasBottom + '">'
        + headHtml
        + '<button type="button" class="cl-nav cl-nav--left" aria-label="Scroll left">' + chev.replace('{P}', '15 18 9 12 15 6') + '</button>'
        + '<div class="saw-track"></div>'
        + '<button type="button" class="cl-nav cl-nav--right" aria-label="Scroll right">' + chev.replace('{P}', '9 6 15 12 9 18') + '</button>'
        + '<div class="cl-progress-container ncl-prog"><div class="cl-progress-bar"></div></div>'
        + '<div class="ncl-more-wrap">' + (cat.code && VIEW_ALL[cat.code] ? '<a class="ncl-more ncl-more--link" href="/collections/' + esc(VIEW_ALL[cat.code]) + '">VIEW ALL</a>' : '<button type="button" class="ncl-more" aria-expanded="false">VIEW MORE</button>') + '</div>'
        + '</div>';
    }
    var images = LAUNCH_BANNERS[cat.code] || [];
    var bm = cat.special === 'top' ? TOP_BN_M : (cat.special === 'new' ? NEW_BN_M : (images[0] || ''));
    var bd = cat.special === 'top' ? TOP_BN_D : (cat.special === 'new' ? NEW_BN_D : (images[1] || ''));
    var tabs = cat.special === 'top'
      ? '<div class="saw-gt-tabs" role="tablist">'
        + (cat.products.length ? '<button type="button" class="saw-gt-tab' + (cat.mode === 'fab' ? ' is-active' : '') + '" data-gt-mode="fab" role="tab">Similar Fabrics</button>' : '')
        + ((cat.styleProducts || []).length ? '<button type="button" class="saw-gt-tab' + (cat.mode === 'sty' ? ' is-active' : '') + '" data-gt-mode="sty" role="tab">Similar Styles</button>' : '')
        + ((cat.pairProducts || []).length ? '<button type="button" class="saw-gt-tab' + (cat.mode === 'pair' ? ' is-active' : '') + '" data-gt-mode="pair" role="tab">Pair It With</button>' : '')
        + '</div>'
      : '';
    var eyebrow = (cat.code && SUPER_LABELS[cat.code]) ? '<div class="saw-cat-eyebrow">' + esc(SUPER_LABELS[cat.code]) + '</div>' : '';
    var headBlock = cat.special === 'top'
      ? '<div class="ncl-txtbn"><h2>Our <b>Most</b> Loved</h2><p>Pieces our customers <b>come back for</b></p></div>'   // new collection template band (owner, 2026-10-01)
      : bannerTitleHtml(bm, bd, cat.label);
    return '<div id="saw-cat-' + cat.slug + '-' + SID + '" class="saw-cat saw-gt-zone' + (cat.special === 'top' ? ' ncl-ml' : '') + '" data-cat="' + cat.slug + '" data-section="' + SID + '" data-top="false" data-bottom="false">'
      + eyebrow
      + headBlock
      + tabs
      + '<div class="saw-gt-grid"></div></div>';
  }
  /* Launch rows alternate their lead image: desktop every 2nd card (2,4,6…), mobile 2,3,5,6,8,9…
     — those cards lead with the product's 4th media instead of the 1st. */
  function altLeads(grid) {
    var desktop = window.matchMedia('(min-width: 1024px)').matches;
    Array.prototype.forEach.call(grid.querySelectorAll('.p-card'), function (card, idx) {
      var car = card.querySelector('.p-car');
      if (!car) return;
      if (!car.getAttribute('data-src-order')) {
        var srcs = Array.prototype.map.call(car.querySelectorAll('img'), function (im) { return im.getAttribute('src'); });
        car.setAttribute('data-src-order', JSON.stringify(srcs));
      }
      var order = JSON.parse(car.getAttribute('data-src-order') || '[]');
      if (order.length < 4) return;
      var i = idx + 1;
      // desktop: every 2nd card. mobile (2-col): zig-zag — cards 2,3, 6,7, 10,11 …
      // so the 4th-image card sits right, left, right, left down the grid.
      var m = i % 4;
      var alt = desktop ? (i % 2 === 0) : (m === 2 || m === 3);
      var want = alt ? order.slice(3, 4).concat(order.slice(0, 3), order.slice(4)) : order;
      if (car.getAttribute('data-alt-applied') === String(alt)) return;
      car.setAttribute('data-alt-applied', String(alt));
      Array.prototype.forEach.call(car.querySelectorAll('img'), function (im, k) {
        if (want[k] && im.getAttribute('src') !== want[k]) im.setAttribute('src', want[k]);
      });
      car.scrollLeft = 0;
    });
  }
  var _altT = null;
  window.addEventListener('resize', function () {
    clearTimeout(_altT);
    _altT = setTimeout(function () {
      categories.forEach(function (c) {
        if (!c.isLaunch || !c.rowEl) return;
        var g = qs('.saw-gt-grid', c.rowEl); if (g) altLeads(g);
      });
    }, 200);
  });
  function renderZone(cat) {
    if (!cat.rowEl) return;
    var grid = qs(cat.carousel ? '.saw-track' : '.saw-gt-grid', cat.rowEl); if (!grid) return;
    var list = cat.products;
    if (cat.special === 'top' && cat.mode === 'sty') list = cat.styleProducts || [];
    if (cat.special === 'top' && cat.mode === 'pair') list = cat.pairProducts || [];
    list = filterList(list);
    grid.innerHTML = list.length ? list.map(function (p) { return cat.special === 'top' || cat.grouped ? mlCardHtml(p) : cardHtml(p); }).join('') : '<div class="saw-loading">No products match.</div>';
    if (cat.carousel) grid.classList.toggle('is-two', list.length === 2);
    var moreW = cat.carousel && qs('.ncl-more-wrap', cat.rowEl); if (moreW) moreW.style.display = list.length > 2 ? '' : 'none';
    if (cat.isLaunch && !cat.carousel) altLeads(grid);   // 4 launch rows: alternate cards lead with the 4th media
    wireCardCarousels(grid);
    /* one launch family in this gender (MEN = Nehru Jacket only): desktop stacks it 5 across instead of a carousel (owner, 2026-10-01) */
    if (cat.carousel && cat.isLaunch) cat.rowEl.classList.toggle('ncl-stack', categories.filter(function (c) { return c.isLaunch; }).length === 1);
    if (cat.carousel) { cat.trackEl = grid; initRowNav(cat); }
    if (!cat._gtTabsBound && cat.special === 'top') {
      cat._gtTabsBound = true;
      qsa('.saw-gt-tab', cat.rowEl).forEach(function (b) {
        b.addEventListener('click', function () {
          cat.mode = b.getAttribute('data-gt-mode');
          qsa('.saw-gt-tab', cat.rowEl).forEach(function (x) { x.classList.toggle('is-active', x === b); });
          renderZone(cat);
        });
      });
    }
  }

  /* Row breaks — one strip after every BREAK_EVERY category carousels, alternating ticker / stats */
  var BREAK_EVERY = parseInt(root.getAttribute('data-break-every'), 10) || 3;
  var STATIC_STRIP = root.getAttribute('data-static-strip') || '';
  /* 2026-10-01: Shop All Women 4 money-back band (assets/saw3.js staticStripHtml markup) replaces the black text bar */
  function staticStripHtml() { return '<div class="saw-static-strip ncl-mbn"><p class="ncl-mbn-t">7 - Day <b>Money Back Guarantee</b></p><p class="ncl-mbn-s">Love it or get your money back</p></div>'; }
  var COPY_BREAKS = (C.copy_breaks || '').split('\n').map(function (s) {
    var ci = s.indexOf('|'); s = s.trim(); if (!s) return null;
    return { h: (ci < 0 ? s : s.slice(0, ci)).trim(), s: ci < 0 ? '' : s.slice(ci + 1).trim() };
  }).filter(Boolean);
  var copyIdx = 0;
  function copyHtml(c) {
    if (c.h.indexOf('img:') === 0) {
      return '<div class="saw-copybreak saw-cbimg"><img class="cb-m" src="' + c.h.slice(4) + '" loading="lazy" alt="">'
        + (c.s ? '<img class="cb-d" src="' + c.s + '" loading="lazy" alt="">' : '') + '</div>';
    }
    var ti = c.h.indexOf('~');
    var hh = ti < 0 ? esc(c.h) : esc(c.h.slice(0, ti)) + '<i>' + esc(c.h.slice(ti + 1)) + '</i>';
    return '<div class="saw-copybreak"><h3>' + hh + '</h3>' + (c.s ? '<p>' + esc(c.s) + '</p>' : '') + '</div>';
  }
  var MQ_TEXT = root.getAttribute('data-marquee') || '';
  function mqHtml() {
    if (!MQ_TEXT) return '';
    var segs = MQ_TEXT.split('·').map(function (t) { return t.trim(); }).filter(Boolean);
    if (!segs.length) segs = [MQ_TEXT];
    var base = segs.map(function (t) { return '<span class="saw-mq-seg">✓ ' + esc(t) + '</span>'; }).join('');   // ✓ prefix — All Linen ticker style
    var half = base + base + base;
    return '<div class="saw-mq"><div class="saw-mq-track">' + half + half + '</div></div>';
  }
  function statsHtml() {
    if (STATS_BN_D || STATS_BN_M) {   // banner mode: artwork replaces the 3 numbers
      var d = STATS_BN_D || STATS_BN_M, m = STATS_BN_M || STATS_BN_D;
      return '<div class="saw-statsbn">'
        + '<img class="saw-statsbn-img saw-statsbn-d" src="' + d + '" alt="" loading="lazy">'
        + '<img class="saw-statsbn-img saw-statsbn-m" src="' + m + '" alt="" loading="lazy">'
        + '</div>';
    }
    return '<div class="saw-stats">'
      + '<div class="saw-stat"><b>' + ((window.__sdCC||{}).lakh||'8 Lakh+') + '</b><span>Happy Customers</span></div>'
      + '<div class="saw-stat"><b>20,000+</b><span>Pincodes Reached</span></div>'
      + '<div class="saw-stat"><b>15 Lakh+</b><span>Products Delivered</span></div>'
      + '</div>';
  }
  function shellsWithBreaks() {
    var out = [], breaks = 0, stripIdx = 0, statsAdded = false, staticShown = false;
    copyIdx = 0;
    var flowCats = categories;
    flowCats.forEach(function (cat, i) {
      if (cat.special === 'top' && !statsAdded && (STATS_BN_D || STATS_BN_M)) {
        out.push(statsHtml());
        statsAdded = true;
      }
      out.push(zoneShellHtml(cat));   // every row is an All Linen stacked grid — no carousels
      var isLast = i === flowCats.length - 1;
      if (!isLast && BREAK_EVERY > 0 && (i + 1) % BREAK_EVERY === 0) {
        if (COPY_BREAKS.length && breaks % 2 === 0 && copyIdx < COPY_BREAKS.length) {
          out.push(copyHtml(COPY_BREAKS[copyIdx++]));
        } else {
          var slot = stripIdx % 3;                        
          var isStats = slot === 2;
          var html = slot === 0 ? staticStripHtml() : (slot === 1 ? mqHtml() : statsHtml());
          if (!html) { html = statsHtml(); isStats = true; }   // blank → keep the stats strip
          if (slot === 0) staticShown = true;
          out.push(html);
          if (isStats) statsAdded = true;
          stripIdx++;
        }
        breaks++;
      }
    });
    if (!statsAdded && (STATS_BN_D || STATS_BN_M)) out.push(statsHtml());
    return out.join('');
  }
  /* roundel rail arrows */
  function updateRoundelNav() {
    if (!roundelRow) return;
    var visTiles = qsa('.saw-roundel', roundelRow).filter(function (t) { return !t.classList.contains('is-hidden') && t.offsetParent !== null; }).length;
    roundelRow.classList.toggle('is-few', visTiles > 0 && visTiles < 5);   // mobile: keep 4-up tile size
    roundelRow.classList.toggle('is-mid', visTiles > 0 && visTiles < 11);
    var wrap = roundelRow.parentNode;
    var prev = qs('.saw-rnav-left', wrap), next = qs('.saw-rnav-right', wrap);
    var max = roundelRow.scrollWidth - roundelRow.clientWidth;
    if (prev) prev.classList.toggle('is-hidden', roundelRow.scrollLeft <= 2);
    if (next) next.classList.toggle('is-hidden', max <= 2 || roundelRow.scrollLeft >= max - 2);
    if (!roundelRow.classList.contains('saw-ready') && !roundelRow.querySelector('[data-pre-tile]')) roundelRow.classList.add('saw-ready');   // 2026-08-17: alignment settled
  }
  setTimeout(function () { if (roundelRow) roundelRow.classList.add('saw-ready'); }, 2500);   // safety: never leave the rail invisible
  function wireRoundelNav() {
    if (!roundelRow || roundelRow._sawNavBound) return;
    roundelRow._sawNavBound = true;
    var wrap = roundelRow.parentNode;
    roundelRow.addEventListener('scroll', function () { requestAnimationFrame(updateRoundelNav); }, { passive: true });
    window.addEventListener('resize', updateRoundelNav);
    qsa('.saw-rnav', wrap).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var dir = parseInt(btn.getAttribute('data-rnav'), 10) || 1;
        roundelRow.scrollBy({ left: dir * Math.round(roundelRow.clientWidth * 0.8), behavior: 'smooth' });
      });
    });
  }
  function mountHero() { updateRoundelNav(); }
  function gthHeroOnScreen() { return false; }
  function renderShells() {
    if (PRE_KEEP && !fetchComplete) {
      // rail keeps the server-rendered tiles until the full list is in — no partial-rail flash
      gridEl.innerHTML = shellsWithBreaks();
      categories.forEach(function (cat) {
        cat.roundelEl = null;
        cat.rowEl     = document.getElementById('saw-cat-' + cat.slug + '-' + SID);
        cat.trackEl   = qs('.saw-track', cat.rowEl);
      });
      wireRoundelNav();
      mountHero();
      return;
    }
    PRE_KEEP = false;
    document.documentElement.classList.remove('saw-deep');   // final rail is in — reveal
    roundelRow.innerHTML = categories.filter(function (cat) { return !cat.hideRoundel; }).map(roundelHtml).join('');
    gridEl.innerHTML = shellsWithBreaks();
    categories.forEach(function (cat) {
      cat.roundelEl = qs('.saw-roundel[data-cat="' + cat.slug + '"]', roundelRow);
      cat.rowEl     = document.getElementById('saw-cat-' + cat.slug + '-' + SID);
      cat.trackEl   = qs('.saw-track', cat.rowEl);
    });
    wireRoundelNav();
    mountHero();
    updateRoundelNav();
  }

  /* ── ALL LINEN CARD ── image carousel + rating pill, title, colour · sizes, colour count, price row ── */
  function esc(t) { return String(t == null ? '' : t).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
  function ratePill(p, toRight) {
    var av = parseFloat(p.rating) || 0;
    if (av <= 0) return '';
    return '<span class="p-rate-pill' + (toRight ? ' is-right' : '') + '">' + av.toFixed(1)
      + '<svg class="p-rate-star" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 2.6l2.7 6.2 6.8.5-5.2 4.4 1.6 6.6L12 16.7 6.1 20.3l1.6-6.6L2.5 9.3l6.8-.5z"/></svg></span>';
  }
  /* Colour count for "Available in N+ colours" — the colour-group metafield when present,
     otherwise the number of loaded colours sharing this style (title minus the colour word). */
  function styleKeyOf(p) {
    var t = (p.title || '');
    if (p.colorName) t = t.replace(p.colorName, '');
    return t.replace(/\s{2,}/g, ' ').trim().toLowerCase();
  }
  function colourCount(p) {
    var meta = (p.siblingGids || []).length;
    if (meta > 1) return meta;
    var k = styleKeyOf(p), n = 0;
    Object.keys(allProducts).forEach(function (h) { if (styleKeyOf(allProducts[h]) === k) n++; });
    return n;
  }
  function cardHtml(p, withAtc) {
    var imgs = (p.images && p.images.length ? p.images : [p.image]).filter(Boolean).slice(0, 5);
    var media;
    if (!imgs.length) {
      media = '<span class="p-noimg" aria-hidden="true"></span>';   // image-less pre-order drafts — soft placeholder, no broken-image icon
    } else if (imgs.length > 1) {
      var dots = '';
      for (var di = 0; di < Math.min(3, imgs.length); di++) dots += '<span' + (di === 0 ? ' class="is-on"' : '') + '></span>';
      var rest = imgs.slice(1).map(function (u) { return cdnImg(u, 440); }).join('|');
      media = '<div class="p-car" data-lazyframes="' + esc(rest) + '">'
        + '<img src="' + cdnImg(imgs[0], 440) + '" loading="lazy" decoding="async" alt="' + esc(p.title) + '">'
        + '</div>'
        + '<div class="p-car-dots">' + dots + '</div>' + (imgs.length > 1 ? '<span class="p-bar" aria-hidden="true"><span style="width:' + Math.round(100 / imgs.length) + '%"></span></span>' : '');
    } else {
      media = '<img src="' + cdnImg(p.image, 440) + '" loading="lazy" decoding="async" alt="' + esc(p.title) + '">';
    }
    var fullTitle = p.title;
    if (p.colorName) fullTitle = fullTitle.replace(p.colorName, '').replace(/\s{2,}/g, ' ').trim();
    var szr = (p.displaySize || '').replace(' - ', ' – ');
    var sub = (p.colorName ? '<span class="p-col">' + esc(p.colorName) + '</span>' : '') + ((p.colorName && szr) ? '<i class="p-dot"> · </i>' : '') + (szr ? '<span class="p-sizes">' + esc(szr) + '</span>' : '');
    var nCol = colourCount(p);
    var off = (p.compare && p.compare > p.price) ? Math.round((p.compare - p.price) / p.compare * 100) : 0;
    var tags = p.tags || [];
    var saveAmount = AIRY_LAUNCH_OFFER && p.isLaunch && !p.isPick3
      ? (['sdapsk', 'sdavsk', 'sdas'].some(function (tag) { return tags.indexOf(tag) !== -1; }) ? 100
        : (['sdaplk', 'sdavlk'].some(function (tag) { return tags.indexOf(tag) !== -1; }) ? 200 : 0))
      : 0;
    if (p.price <= saveAmount) saveAmount = 0;
    var showOffer = saveAmount > 0;
    var subHtml = '<div class="p-sub">' + (sub || '&nbsp;') + '</div>';
    var rv = parseFloat(p.rating) || 0, rn = parseInt(p.raters, 10) || 0;
    var stars = rateRowHtml(p, 'div', !!p.isNewColor);   // new colours: grouped family reviews; others product-wise
    return '<div class="p-card' + (p.isNewColor ? ' is-newcol' : '') + '" data-handle="' + encodeURIComponent(p.handle) + '"' + (p.isPick3 ? ' data-pick3-link="' + esc(p.link) + '"' : '') + '>'
      + '<div class="p-img-box">' + media + (p.isNewColor ? '<span class="p-pre-pill ncl-new">' + esc(NEW_BADGE) + '</span>' : '')
      + '<div class="ncl-meta"><span>' + esc(p.colorName || '') + '</span>' + (szr ? '<span>' + esc(szr) + '</span>' : '') + '</div></div>'
      + '<div class="p-price-row"><span class="p-price">₹ ' + inr.format(p.price) + '</span>'
      + (p.compare && p.compare > p.price ? '<span class="p-compare">₹ ' + inr.format(p.compare) + '</span>' : '')
      + (off > 0 ? '<span class="p-off">' + off + '% OFF</span>' : '')
      + '</div>' + stars
      + (showOffer ? '<div class="p-best-price"><span class="p-best-icon" aria-hidden="true">%</span>Best price ₹' + inr.format(p.price - saveAmount) + '</div>' : '')
      + (withAtc ? '<button type="button" class="p-atc">' + (p.isNewColor ? 'EARLY ACCESS' : 'ADD TO BAG') + '</button>' : '')
      + '</div>';
  }
  /* Most Loved card = the new collection template's card (snippets/ncp3-card.liquid): frames, then title + size span,
     ₹ price + MRP + slanted % OFF, star row, "Available in N+ colours", slide hint. */
  var mlPool = [];
  var LOOX_STORE = '41bcGRiHIp.fc54fa5d815a0186b7d4ddc303c06f787a23ae7bad2675958bee4ded03c93426';
  function rateOf(p, grouped) {
    if (grouped && parseFloat(p.famRating) > 0) return { r: parseFloat(p.famRating), n: parseInt(p.famRaters, 10) || 0, pid: String(p.gid || '').split('/').pop() };
    var r = parseFloat(p.rating) || 0;
    if (r > 0) return { r: r, n: parseInt(p.raters, 10) || 0, pid: String(p.gid || '').split('/').pop() };
    var k = styleKeyOf(p), best = null;   // new colour / unrated colour → the family's grouped rating (Loox groups per style)
    (mlPool || []).concat(Object.keys(allProducts).map(function (h) { return allProducts[h]; })).forEach(function (q) {
      if (!q || q.handle === p.handle || styleKeyOf(q) !== k || !(parseFloat(q.famRating || q.rating) > 0)) return;
      if (!best || (parseInt(q.famRaters || q.raters, 10) || 0) > (parseInt(best.famRaters || best.raters, 10) || 0)) best = q;
    });
    return best ? { r: parseFloat(best.famRating || best.rating), n: parseInt(best.famRaters || best.raters, 10) || 0, pid: String(best.gid || '').split('/').pop() } : null;   // family (grouped) numbers
  }
  function familyPids(p) {   // every colour of the style that has reviews — the grouped reviews list
    var k = styleKeyOf(p), seen = {}, out = [];
    [p].concat(mlPool || [], Object.keys(allProducts).map(function (h) { return allProducts[h]; })).forEach(function (q) {
      if (!q || seen[q.handle] || styleKeyOf(q) !== k) return; seen[q.handle] = 1;
      var id = String(q.gid || '').split('/').pop(); if (id) out.push(id);
    });
    return out.slice(0, 12);
  }
  function rateRowHtml(p, cls, grouped) {
    var x = rateOf(p, grouped); if (!x) return '';
    var full = Math.round(x.r), st = '';
    for (var si = 1; si <= 5; si++) st += '<span' + (si <= full ? ' class="on"' : '') + '><svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 2.6l2.7 6.2 6.8.5-5.2 4.4 1.6 6.6L12 16.7 6.1 20.3l1.6-6.6L2.5 9.3l6.8-.5z"/></svg></span>';
    return '<' + (cls || 'div') + ' class="ncl-rate" role="button" tabindex="0" data-ncl-rv="1" data-pid="' + esc(x.pid) + '"' + (grouped ? ' data-pids="' + esc(familyPids(p).join(',')) + '"' : '') + ' data-title="' + esc(p.title) + '" data-rating="' + x.r.toFixed(1) + '" data-count="' + x.n + '"><span class="ncl-stars">' + st + '</span><b>' + x.r.toFixed(1) + '</b>' + (x.n ? '<span class="ncl-cnt">(' + x.n + ')</span>' : '') + '</' + (cls || 'div') + '>';
  }
  /* other in-stock colours of the same style (title minus colour), best seller first — the Most Loved slide (ncp3 card rule) */
  function mlSiblings(p) {
    var k = styleKeyOf(p), seen = {}, out = [];
    seen[p.handle] = 1;
    (mlPool || []).concat(Object.keys(allProducts).map(function (h) { return allProducts[h]; })).forEach(function (q) {
      if (!q || seen[q.handle] || !q.image || styleKeyOf(q) !== k || !((q.totalInv || 0) > 0)) return;
      seen[q.handle] = 1; out.push(q);
    });
    out.sort(function (a, b) { return (a.rank || 9e8) - (b.rank || 9e8); });
    return out.slice(0, 7);
  }
  function mlCardHtml(p) {
    var imgs = (p.images && p.images.length ? p.images : [p.image]).filter(Boolean).slice(0, 5);
    var sibs = mlSiblings(p);
    /* frames = this colour, then the family's other colours (each frame opens its own colour); no siblings → own photos */
    var rest = sibs.length ? sibs.map(function (q) { return q.link + '^' + cdnImg(q.image, 440); }) : imgs.slice(1).map(function (u) { return cdnImg(u, 440); });
    if (sibs.length) imgs = [imgs[0]].concat(sibs.map(function (q) { return q.image; }));
    var media = !imgs.length ? '<span class="p-noimg" aria-hidden="true"></span>'
      : '<div class="p-car"' + (rest.length ? ' data-lazyframes="' + esc(rest.join('|')) + '"' : '') + '><img src="' + cdnImg(imgs[0], 440) + '" loading="lazy" decoding="async" alt="' + esc(p.title) + '"></div>';
    var label = p.title; if (p.colorName) label = label.replace(p.colorName, '').replace(/\s{2,}/g, ' ').trim();
    var szr = (p.displaySize || '').replace(' - ', ' – ');
    var off = (p.compare && p.compare > p.price) ? Math.round((p.compare - p.price) / p.compare * 100) : 0;
    var stars = rateRowHtml(p, 'span', true);   // Most Loved: grouped family reviews
    var nCol = colourCount(p);
    return '<div class="p-card ncl-mlc' + (p.isNewColor ? ' is-newcol' : '') + '" data-handle="' + encodeURIComponent(p.handle) + '"' + (p.isPick3 ? ' data-pick3-link="' + esc(p.link) + '"' : '') + '>'
      + '<div class="p-img-box">' + media + (imgs.length > 1 ? '<span class="p-bar" aria-hidden="true"><span style="width:' + Math.round(100 / imgs.length) + '%"></span></span>' : '') + (p.isNewColor ? '<span class="p-pre-pill ncl-new">' + esc(NEW_BADGE) + '</span>' : '') + '</div>'
      + '<div class="ncl-body"><span class="ncl-ttl-row"><span class="ncl-ttl">' + esc(label) + '</span>' + (szr ? '<span class="ncl-size">' + esc(szr) + '</span>' : '') + '</span>'
      + '<span class="p-price-row"><span class="p-price">₹ ' + inr.format(p.price) + '</span>'
      + (p.compare && p.compare > p.price ? '<span class="p-compare">₹ ' + inr.format(p.compare) + '</span>' : '')
      + (off > 0 ? '<span class="p-off">' + off + '% OFF</span>' : '') + '</span>'
      + stars
      + (nCol >= 2 ? '<span class="ncl-cols">Available in ' + (nCol - 1) + '+ colours</span><span class="ncl-slide">Slide right to view more colors &rarr;</span>' : '')
      + '</div></div>';
  }
  /* card image carousel dots */
  function updateCarBar(car) {   /* saw3 rule: fills left → right with the frame scroll */
    var bar = car.parentNode && car.parentNode.querySelector('.p-bar > span'); if (!bar) return;
    var max = car.scrollWidth - car.clientWidth; if (max <= 0) return;
    var one = car.clientWidth / car.scrollWidth * 100;
    bar.style.width = (one + (100 - one) * (car.scrollLeft / max)) + '%';
  }
  function updateCarDots(car) {
    updateCarBar(car);
    var dots = car.parentNode && car.parentNode.querySelector('.p-car-dots');
    if (!dots || !car.firstElementChild) return;
    var i = Math.round(car.scrollLeft / car.firstElementChild.clientWidth);
    var spans = dots.children, total = car.children.length, shown = spans.length;
    var start = Math.max(0, Math.min(i - 1, total - shown));
    for (var d = 0; d < shown; d++) spans[d].classList.toggle('is-on', start + d === i);
  }
  /* Gesture-driven, never observer-driven: an IntersectionObserver left rows blank when this was
     tried on campaign3, so frames are injected on a real touch/hover/scroll of that card. */
  function expandCar(car) {
    var rest = car.getAttribute('data-lazyframes');
    if (!rest) return;
    car.removeAttribute('data-lazyframes');
    var first = car.querySelector('img');
    var alt = first ? (first.getAttribute('alt') || '') : '';
    car.insertAdjacentHTML('beforeend', rest.split('|').filter(Boolean).map(function (u) {
      var pair = u.split('^'), src = pair[pair.length - 1];   // "link^src" = a sibling colour frame that opens its own product
      var img = '<img src="' + src + '" loading="lazy" decoding="async" alt="' + alt + '">';
      return pair.length > 1 ? '<a class="p-frame" href="' + pair[0] + '">' + img + '</a>' : img;
    }).join(''));
  }
  var nclArrow = function (d) { return '<svg viewBox="0 0 24 24" aria-hidden="true"><polyline points="' + (d < 0 ? '15 5 8 12 15 19' : '9 5 16 12 9 19') + '"/></svg>'; };
  root.addEventListener('mouseover', function (e) {   /* built on first hover, like saw3 — nothing on phones */
    var card = e.target.closest && e.target.closest('.p-card'); if (!card || card.querySelector('.p-nav')) return;
    var car = card.querySelector('.p-car'), box = card.querySelector('.p-img-box'); if (!car || !box) return;
    expandCar(car);
    var nav = document.createElement('span'); nav.className = 'p-nav';
    nav.innerHTML = '<button type="button" data-ncl-step="-1" aria-label="Previous image">' + nclArrow(-1) + '</button>'
      + '<button type="button" data-ncl-step="1" aria-label="Next image">' + nclArrow(1) + '</button>';
    box.appendChild(nav);
    requestAnimationFrame(function () { if (car.scrollWidth > car.clientWidth + 2) nav.classList.add('is-on'); });
  }, true);
  root.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-ncl-step]'); if (!b) return;
    e.preventDefault(); e.stopPropagation();
    var car = b.closest('.p-card').querySelector('.p-car'), w = car.clientWidth, d = Number(b.getAttribute('data-ncl-step'));
    var max = car.scrollWidth - w, next = car.scrollLeft + d * w;
    if (next < -1) next = max; else if (next > max + 1) next = 0;
    car.scrollTo({ left: next, behavior: 'auto' });
  }, true);
  var nclRvCache = {};
  function nclRvFetch(pid, page) {
    var key = pid + ':' + page;
    if (!nclRvCache[key]) nclRvCache[key] = fetch('https://storefront-api.loox.io/storefront/v1/store/' + LOOX_STORE + '/product-reviews?product_id=' + pid + '&page=' + page + '&limit=' + (page === 1 ? 6 : 10)).then(function (r) { return r.ok ? r.json() : null; });
    return nclRvCache[key];
  }
  function nclRvStars(n) { var o = ''; for (var i = 1; i <= 5; i++) o += '<svg class="' + (i <= n ? 'on' : '') + '" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2.6l2.7 6.2 6.8.5-5.2 4.4 1.6 6.6L12 16.7 6.1 20.3l1.6-6.6L2.5 9.3l6.8-.5z"/></svg>'; return '<span class="saw3-rv-stars">' + o + '</span>'; }
  function nclRvThumb(u, w) { return 'https://images.loox.io/cdn-cgi/image/width=' + w + ',quality=72,format=auto' + String(u).replace(/^https?:\/\/images\.loox\.io/, ''); }
  function nclRvBox() {
    var box = root.querySelector('[data-ncl-rvbox]'); if (box) return box;
    root.insertAdjacentHTML('beforeend', '<div class="saw3-rv-scrim" data-ncl-rvscrim hidden></div><div class="saw3-rv" data-ncl-rvbox role="dialog" aria-modal="true" aria-label="Reviews" hidden>'
      + '<div class="saw3-rv-head"><div><span class="saw3-rv-kicker">Reviews</span><span class="saw3-rv-title" data-ncl-rvttl></span><span class="saw3-rv-sub" data-ncl-rvsub></span></div>'
      + '<button type="button" class="saw3-rv-close" data-ncl-rvclose aria-label="Close"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><line x1="6" y1="6" x2="18" y2="18"/><line x1="18" y1="6" x2="6" y2="18"/></svg></button></div>'
      + '<div class="saw3-rv-list" data-ncl-rvlist></div></div>');
    return root.querySelector('[data-ncl-rvbox]');
  }
  function nclRvLoad(pid, list, page) {
    var old = list.querySelector('.saw3-rv-more'); if (old) old.remove();
    nclRvFetch(pid, page).then(function (d) {
      var rows = (d && d.reviews) || [];
      if (!rows.length && page === 1) { list.innerHTML = '<p class="saw3-rv-empty">No reviews yet.</p>'; return; }
      if (page === 1) list.innerHTML = '<div class="saw3-rv-bar">' + nclRvStars(5) + '<span class="saw3-rv-total">' + ((d.pagination || {}).total || rows.length).toLocaleString('en-IN') + ' Reviews</span></div><div class="saw3-rv-grid" data-ncl-rvgrid></div>';
      var grid = list.querySelector('[data-ncl-rvgrid]') || list, narrow = window.matchMedia('(max-width: 768px)').matches;
      rows.forEach(function (rv) {
        var m = (rv.media || []).filter(function (x) { return x.url; })[0], el = document.createElement('article');
        el.className = 'saw3-rv-item';
        el.innerHTML = (m ? '<div class="saw3-rv-media"><img src="' + esc(nclRvThumb(m.url, narrow ? 360 : 480)) + '" alt="" decoding="async" onload="this.classList.add(\'is-on\')"></div>' : '')
          + '<div class="saw3-rv-txt"><span class="saw3-rv-who">' + esc((rv.reviewer && rv.reviewer.name) || 'Verified buyer') + '</span>' + nclRvStars(rv.rating || 0) + (rv.body ? '<p class="saw3-rv-body">' + esc(rv.body) + '</p>' : '') + '</div>';
        grid.appendChild(el);
      });
      if ((d.pagination || {}).hasMore) {
        var b = document.createElement('button'); b.type = 'button'; b.className = 'saw3-rv-more'; b.textContent = 'Show more reviews';
        b.addEventListener('click', function () { b.disabled = true; nclRvLoad(pid, list, page + 1); });
        list.appendChild(b);
      }
    }).catch(function () { if (page === 1) list.innerHTML = '<p class="saw3-rv-empty">Could not load reviews.</p>'; });
  }
  function nclRvLoadGroup(pids, list, page) {
    var old = list.querySelector('.saw3-rv-more'); if (old) old.remove();
    Promise.all(pids.map(function (id) { return nclRvFetch(id, page).catch(function () { return null; }); })).then(function (ds) {
      var rows = [], total = 0, more = [];
      ds.forEach(function (d, i) { if (!d) return; rows = rows.concat(d.reviews || []); total += (d.pagination || {}).total || 0; if ((d.pagination || {}).hasMore) more.push(pids[i]); });
      rows.sort(function (a, b) { return String(b.date || b.created_at || '').localeCompare(String(a.date || a.created_at || '')); });
      if (!rows.length && page === 1) { list.innerHTML = '<p class="saw3-rv-empty">No reviews yet.</p>'; return; }
      if (page === 1) list.innerHTML = '<div class="saw3-rv-bar">' + nclRvStars(5) + '<span class="saw3-rv-total">' + total.toLocaleString('en-IN') + ' Reviews · all colours</span></div><div class="saw3-rv-grid" data-ncl-rvgrid></div>';
      var grid = list.querySelector('[data-ncl-rvgrid]') || list, narrow = window.matchMedia('(max-width: 768px)').matches;
      rows.forEach(function (rv) {
        var m = (rv.media || []).filter(function (x) { return x.url; })[0], el = document.createElement('article');
        el.className = 'saw3-rv-item';
        el.innerHTML = (m ? '<div class="saw3-rv-media"><img src="' + esc(nclRvThumb(m.url, narrow ? 360 : 480)) + '" alt="" decoding="async" onload="this.classList.add(\'is-on\')"></div>' : '')
          + '<div class="saw3-rv-txt"><span class="saw3-rv-who">' + esc((rv.reviewer && rv.reviewer.name) || 'Verified buyer') + '</span>' + nclRvStars(rv.rating || 0) + (rv.body ? '<p class="saw3-rv-body">' + esc(rv.body) + '</p>' : '') + '</div>';
        grid.appendChild(el);
      });
      if (more.length) {
        var b = document.createElement('button'); b.type = 'button'; b.className = 'saw3-rv-more'; b.textContent = 'Show more reviews';
        b.addEventListener('click', function () { b.disabled = true; nclRvLoadGroup(more, list, page + 1); });
        list.appendChild(b);
      }
    });
  }
  function nclRvOpen(el) {
    var box = nclRvBox(), scrim = root.querySelector('[data-ncl-rvscrim]');
    box.querySelector('[data-ncl-rvttl]').textContent = el.getAttribute('data-title') || '';
    var n = Number(el.getAttribute('data-count') || 0);
    box.querySelector('[data-ncl-rvsub]').innerHTML = '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 2.6l2.7 6.2 6.8.5-5.2 4.4 1.6 6.6L12 16.7 6.1 20.3l1.6-6.6L2.5 9.3l6.8-.5z"/></svg> <b>' + esc(el.getAttribute('data-rating') || '') + '</b>' + (n ? ' <span class="saw3-rv-dot">·</span> ' + n.toLocaleString('en-IN') + ' reviews' : '');
    var list = box.querySelector('[data-ncl-rvlist]'); list.innerHTML = '';
    box.hidden = false; scrim.hidden = false; document.documentElement.style.overflow = 'hidden';
    var pids = (el.getAttribute('data-pids') || '').split(',').map(function (s) { return s.replace(/\D/g, ''); }).filter(Boolean);
    if (pids.length > 1) { nclRvLoadGroup(pids, list, 1); return; }
    nclRvLoad(String(el.getAttribute('data-pid') || '').replace(/\D/g, ''), list, 1);
  }
  function nclRvClose() { var box = root.querySelector('[data-ncl-rvbox]'); if (!box || box.hidden) return; box.hidden = true; root.querySelector('[data-ncl-rvscrim]').hidden = true; document.documentElement.style.overflow = ''; }
  root.addEventListener('click', function (e) {   // capture: the rating opens reviews before the card's own tap → PDP
    var r = e.target.closest && e.target.closest('[data-ncl-rv]');
    if (r) { e.preventDefault(); e.stopPropagation(); nclRvOpen(r); return; }
    if (e.target.closest && (e.target.closest('[data-ncl-rvclose]') || e.target.closest('[data-ncl-rvscrim]'))) { e.preventDefault(); e.stopPropagation(); nclRvClose(); return; }
    if (e.target.closest && e.target.closest('[data-ncl-rvbox]')) { e.stopPropagation(); }
  }, true);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') nclRvClose(); });
  function wireCardCarousels(scope) {
    qsa('.p-car', scope || root).forEach(function (car) {
      if (car._sawCarBound) return;
      car._sawCarBound = true;
      var expand = function () { expandCar(car); };
      car.addEventListener('touchstart', expand, { passive: true });
      car.addEventListener('mouseenter', expand);
      car.addEventListener('scroll', function () {
        expandCar(car);
        requestAnimationFrame(function () { updateCarDots(car); });
      }, { passive: true });
    });
  }

  function filterList(list) {
    return list.filter(function (p) {
      if (filterState.size && p.sizes.indexOf(filterState.size) === -1) return false;
      if (filterState.colors.length && filterState.colors.indexOf((p.colorName || '').toLowerCase().trim()) === -1) return false;
      if (filterState.family && filterState.family.length && !filterState.family.some(function (ff) { return (p.tags || []).indexOf(ff.toLowerCase()) !== -1; })) return false;
      if (p.price < filterState.minPrice || p.price > filterState.maxPrice) return false;
      return true;
    });
  }
  function filteredProducts(cat) {
    var base = cat.special === 'top' ? cat.products.concat(cat.styleProducts || [], cat.pairProducts || []) : cat.products;
    return filterList(base);
  }
  function renderRow(cat) {
    renderZone(cat); return;   // all rows are stacked grids now (All Linen layout)
    if (!cat.trackEl) return;
    var list = filteredProducts(cat);
    cat.trackEl.innerHTML = list.length ? list.map(function (p) { return cardHtml(p); }).join('') : '<div class="saw-loading">No products match.</div>';   // no bare map(cardHtml) — index would leak into withAtc
    wireCardCarousels(cat.trackEl);
    initRowNav(cat);
  }
  root.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('button.ncl-more'); if (!b) return;   // the VIEW ALL link just navigates
    var row = b.closest('.saw-cat'); if (!row) return;
    var open = !row.classList.contains('ncl-open');
    row.classList.toggle('ncl-open', open);
    b.textContent = open ? 'VIEW LESS' : 'VIEW MORE'; b.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (!open) row.scrollIntoView({ block: 'start', behavior: 'smooth' });
  });
  function renderVisibleRows() {
    categories.forEach(function (cat) { if (cat.rowEl && !cat.rowEl.classList.contains('is-hidden')) renderRow(cat); });
    startFomoLive();
  }

  function initRowNav(cat) {
    var track = cat.trackEl, wrap = cat.rowEl;
    var bar = qs('.cl-progress-bar', wrap), leftBtn = qs('.cl-nav--left', wrap), rightBtn = qs('.cl-nav--right', wrap);
    if (!track) return;
    function update() {
      var max = track.scrollWidth - track.clientWidth;
      if (bar) {
        if (bar.parentElement) bar.parentElement.style.display = max <= 2 ? 'none' : '';   // 2026-08-17: nothing to scroll -> no progress bar
        bar.style.width = max <= 0 ? '12%' : Math.min(100, Math.max(12, (track.scrollLeft / max) * 100)) + '%';
      }
      if (leftBtn && rightBtn) {
        if (max <= 2) { leftBtn.classList.remove('is-visible'); rightBtn.classList.remove('is-visible'); return; }
        leftBtn.classList.toggle('is-visible', track.scrollLeft > 2);
        rightBtn.classList.toggle('is-visible', track.scrollLeft < max - 2);
      }
    }
    function step(dir) { track.scrollBy({ left: dir * Math.round(track.clientWidth * 0.85), behavior: 'smooth' }); }
    if (!track._sawBound) {
      track._sawBound = true;
      var rafPending = false;   // one measure per frame — re-measuring on every scroll event made phone swipes janky
      track.addEventListener('scroll', function () { if (rafPending) return; rafPending = true; requestAnimationFrame(function () { rafPending = false; update(); }); }, { passive: true });
      window.addEventListener('resize', update);
      if (leftBtn)  leftBtn.addEventListener('click', function () { step(-1); });
      if (rightBtn) rightBtn.addEventListener('click', function () { step(1); });
    }
    setTimeout(update, 60);
  }

  /* ───────── group toggle (tag-based) ───────── */
  /* 2026-08-14: breaks (banner/marquee/stats) show only with a VISIBLE row on both sides */
  function pruneBreaks() {
    var first = null;
    for (var ci = 0; ci < categories.length; ci++) { if (categories[ci].rowEl) { first = categories[ci].rowEl; break; } }
    if (!first || !first.parentNode) return;
    var kids = Array.prototype.slice.call(first.parentNode.children);
    function isBreak(el) { return /(^| )(saw-static-strip|saw-mq|saw-stats|saw-statsbn|saadaa-statsbn|saw-copybreak)( |$)/.test(el.className || ''); }
    var specials = [];   // Most Loved / Top Rated / Happening Now / Pair It With are sections, not category rows
    categories.forEach(function (c) { if (c.special && c.rowEl) specials.push(c.rowEl); });
    function isVisZone(el) { return el.classList && el.classList.contains('saw-cat') && !el.classList.contains('is-hidden') && specials.indexOf(el) === -1; }
    var seenZone = false, pending = null, kept = [];
    kids.forEach(function (el) {
      if (isBreak(el)) {
        el.classList.add('is-hidden');
        var bnd = /(^| )saw-copybreak( |$)/.test(el.className || '');
        if (seenZone && (!pending || (bnd && !/(^| )saw-copybreak( |$)/.test(pending.className || '')))) pending = el;
        return;
      }
      if (isVisZone(el)) {
        if (pending) { pending.classList.remove('is-hidden'); kept.push(pending); pending = null; }
        seenZone = true;
      }
    });
    /* a single-row view (MEN: Nehru Jacket only) has no gap between two rows — keep the band after the last row (owner, 2026-10-01) */
    if (!kept.length && pending) { pending.classList.remove('is-hidden'); kept.push(pending); }
     var makers = [staticStripHtml, mqHtml, statsHtml];
    kept = kept.filter(function (el) { return !/(^| )saw-copybreak( |$)/.test(el.className || ''); });   // copy bands keep their own content
    kept.forEach(function (el, ki) {
      var html = makers[ki % 3]() || makers[(ki + 2) % 3]() || makers[(ki + 1) % 3]();
      if (!html) return;
      var tmp = document.createElement('div');
      tmp.innerHTML = html;
      var neo = tmp.firstElementChild;
      if (neo && !new RegExp('(^| )' + (neo.className || '').split(' ')[0] + '( |$)').test(el.className || '')) {
        el.parentNode.replaceChild(neo, el);
      }
    });
  }
  function applyGroupVisibility() {
    categories.forEach(function (cat) {
      if (!cat.rowEl) return;
      var groupOk = !activeGroup || (activeGroup === 'top' ? cat.hasTop : cat.hasBottom);
      var visible = groupOk && filteredProducts(cat).length > 0;
      cat.rowEl.classList.toggle('is-hidden', !visible);
      if (cat.roundelEl) cat.roundelEl.classList.toggle('is-hidden', !visible);
    });
    renderVisibleRows();
    var firstVisible = categories.find(function (c) { return !c.hideRoundel && c.rowEl && !c.rowEl.classList.contains('is-hidden'); });
    if (firstVisible && !urlCatPending()) setActiveRoundel(firstVisible.slug);
    else if (urlCatPending()) qsa('.saw-roundel.is-active', root).forEach(function (r) { r.classList.remove('is-active'); });
    var emptyEl = document.getElementById('saw-empty-' + SID);
    if (emptyEl) emptyEl.style.display = firstVisible ? 'none' : 'block';
    pruneBreaks();
    updateRoundelNav();
    updateFfReveal();
    setupSpy();
  }
  function setActiveToggle() {
    qsa('.saw-toggle-btn', root).forEach(function (b) {
      var g = b.getAttribute('data-group');
      b.classList.toggle('is-active', (activeGroup === null && g === 'all') || g === activeGroup);
    });
  }
  function bindToggle() {
    qsa('.saw-toggle-btn', root).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var g = btn.getAttribute('data-group');
        activeGroup = (g === 'all') ? null : g;
        setActiveToggle();
        applyGroupVisibility();
        var top = gridEl.getBoundingClientRect().top + window.pageYOffset - (getHeaderHeight() + stickyHeight()) - 4;
        window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
        setTimeout(syncSpy, 450);
      });
    });
  }

  /* ───────── sticky roundel nav + scroll-spy ───────── */
  function getHeaderHeight() {
    var header = qs('header[id^="shopify-section"]') || qs('header.site-header') || qs('.section-header') || qs('#shopify-section-header');
    var ann = qs('.announcement-bar');
    var h = header ? header.getBoundingClientRect().height : 0;
    if (ann) h += ann.getBoundingClientRect().height;
    return h > 0 ? h : 72;
  }
  function stickyHeight() { var b = document.getElementById('saw-sticky-' + SID); return b ? b.offsetHeight : 80; }
  function handleSticky() {
    var spacer = document.getElementById('saw-roundel-spacer-' + SID);
    var bar = document.getElementById('saw-sticky-' + SID);
    if (!spacer || !bar) return;
    var hh = getHeaderHeight();
    if (spacer.getBoundingClientRect().top <= hh) {
      if (!bar.classList.contains('is-locked')) {
        spacer.style.height = bar.offsetHeight + 'px';
        bar.classList.add('is-locked');
        root.style.setProperty('--saw-sticky-top-' + SID, hh + 'px');
        bar.style.top = hh + 'px';
        window.setTimeout(handleSticky, 320);   // remeasure after the countdown rail finishes opening
      }
      spacer.style.height = bar.offsetHeight + 'px';
    } else if (bar.classList.contains('is-locked')) {
      bar.classList.remove('is-locked');
      spacer.style.height = 'auto';
    }
    root.style.setProperty('--saw-tabs-top-' + SID, (hh + (bar.classList.contains('is-locked') ? bar.offsetHeight : 0)) + 'px');
  }
  function ensureRoundelInView(slug) {
    var item = qs('.saw-roundel[data-cat="' + slug + '"]', roundelRow);
    if (!roundelRow || !item) return;
    var rr = roundelRow.getBoundingClientRect(), ir = item.getBoundingClientRect();
    if (!(ir.left < rr.left + 10) && !(ir.right > rr.right - 10)) return;
    roundelRow.scrollTo({ left: Math.max(0, item.offsetLeft - roundelRow.clientWidth / 2 + item.clientWidth / 2), behavior: 'smooth' });
  }
  var lastActiveSlug = null;
  function setActiveRoundel(slug) {
    qsa('.saw-roundel', roundelRow).forEach(function (lbl) { lbl.classList.toggle('is-active', lbl.getAttribute('data-cat') === slug); });
    if (slug !== lastActiveSlug) { lastActiveSlug = slug; ensureRoundelInView(slug); }   // only auto-scroll the nav when the active actually changes
  }
  var manualLockUntil = 0;
  // ?category= target not streamed in yet (best-sellers-first paging) — hold every tile dark so tile 1 never lights then jumps
  function urlCatPending() { return !!URL_CAT && !fetchComplete && !categories.some(function (c) { return normCat(c.slug) === URL_CAT || normCat(c.label) === URL_CAT; }); }
  function syncSpy() {
    if (urlCatPending()) return;
    if (Date.now() < manualLockUntil) return;
    var offset = getHeaderHeight() + stickyHeight() + 10;
    var anchors = [];
    categories.forEach(function (cat) { if (!cat.hideRoundel && cat.rowEl && !cat.rowEl.classList.contains('is-hidden')) anchors.push({ slug: cat.slug, el: cat.rowEl }); });
    if (!anchors.length) return;
    var active = 0;
    for (var i = 0; i < anchors.length; i++) { if (anchors[i].el.getBoundingClientRect().top - offset <= 15) active = i; }
    setActiveRoundel(anchors[active].slug);
  }

  // Robust scroll-spy via IntersectionObserver (works inside editor iframe / custom scroll containers)
  var spyIO = null;
  function setupSpy() {
    if (spyIO) { spyIO.disconnect(); spyIO = null; }
    if (!('IntersectionObserver' in window)) return;
    spyIO = new IntersectionObserver(function () { syncSpy(); }, { threshold: [0, 0.05, 0.2, 0.5, 0.85, 1] });
    categories.forEach(function (c) { if (!c.hideRoundel && c.rowEl && !c.rowEl.classList.contains('is-hidden')) spyIO.observe(c.rowEl); });
  }

  /* ───────── quick-add overlay ───────── */
  var qaMedia = id('saw-qa-media'), qaProg = id('saw-qa-progbar');
  function updateQaProgress() {
    if (!qaMedia || !qaProg) return;
    var max = qaMedia.scrollWidth - qaMedia.clientWidth;
    if (max <= 0) { qaProg.style.width = '100%'; return; }
    var base = (qaMedia.clientWidth / qaMedia.scrollWidth) * 100;
    qaProg.style.width = (base + (qaMedia.scrollLeft / max) * (100 - base)) + '%';
  }
  if (qaMedia) qaMedia.addEventListener('scroll', function () { requestAnimationFrame(updateQaProgress); }, { passive: true });

  // Renders the price block shown below the title: sale price + slashed MRP + shiny % OFF badge
  function renderPriceBlock(price) {
    var pb = id('saw-qa-priceblock'); if (!pb) return;
    var ovr = qaCurrentProduct ? launchPriceFor(qaCurrentProduct.tags || []) : 0;
    if (ovr > 0 && ovr < price) price = ovr;   // launch special price — matches the card
    var compare = (qaCurrentProduct && qaCurrentProduct.compare && qaCurrentProduct.compare > price) ? qaCurrentProduct.compare : price * COMPARE_MULT;
    var off = compare > price ? Math.round((compare - price) / compare * 100) : 0;
    pb.innerHTML = '<span class="saw-qa-pb-price">₹ ' + inr.format(price) + '</span>'
      + (compare > price ? '<span class="saw-qa-pb-mrp">MRP ₹ ' + inr.format(compare) + '</span>' : '')
      + (off > 0 ? '<span class="saw-qa-pb-badge">' + off + '% OFF</span>' : '');
    // BUY deal bar — flat 10% off, derived from the selected price
    var dp = id('saw-deal-price'), ds = id('saw-deal-save');
    if (dp) dp.textContent = '₹' + inr.format(Math.round(price * 0.90));
    if (ds) ds.textContent = 'You save ₹' + inr.format(Math.round(price * 0.10));
  }

  /* Overview colour row — every loaded colour of this style, All Linen style dots */
  function siblingColours(p) {
    var k = styleKeyOf(p), out = [];
    Object.keys(allProducts).forEach(function (h) {
      var q = allProducts[h];
      if (q && styleKeyOf(q) === k) out.push(q);
    });
    out.sort(function (a, b) { return (a.colorName || '').localeCompare(b.colorName || ''); });
    return out;
  }
  function renderQaColors(p) {
    var row = id('saw-qa-colors'), head = id('saw-qa-colorhead'), nameEl = id('saw-qa-colorname');
    if (!row) return;
    var sibs = siblingColours(p);
    if (sibs.length < 2) { row.innerHTML = ''; if (head) head.style.display = 'none'; return; }
    if (head) head.style.display = '';
    if (nameEl) nameEl.innerText = p.colorName ? (' : ' + p.colorName) : '';
    row.innerHTML = sibs.map(function (q) {
      var sw = q.swatch || SWATCH_MAP[(q.colorName || '').toLowerCase().trim()] || '';
      var style = sw ? 'background:' + sw + ';' : (q.image ? 'background-image:url(' + q.image + ');' : 'background:#ccc;');
      return '<div class="saw-qa-color' + (q.handle === p.handle ? ' is-active' : '') + '" data-qa-color="' + encodeURIComponent(q.handle) + '"'
        + ' title="' + esc(q.colorName || '') + '" style="' + style + '"></div>';
    }).join('');
  }
  function openQuickAdd(handle, hideOffer) {
    var p = allProducts[handle];
    if (!p) return;
    qaCurrentProduct = p;
    qaHideOffer = !!hideOffer;
    var addBtn = id('saw-qa-add'), bnBtn = id('saw-qa-buynow');
    if (addBtn) { addBtn.disabled = false; addBtn.innerText = addLabel(); }
    if (bnBtn)  { bnBtn.disabled = false;  bnBtn.innerText = bnLabel(); }

    var media = id('saw-qa-media'), pw = id('saw-qa-progwrap');
    if (media) {
      media.innerHTML = p.images.map(function (i) { return '<img src="' + cdnImg(i, 900) + '" loading="lazy" decoding="async">'; }).join('');
      if (p.images.length > 1) { if (pw) pw.style.display = 'flex'; setTimeout(function () { media.scrollLeft = 0; updateQaProgress(); }, 50); }
      else if (pw) pw.style.display = 'none';
    }
    var titleEl = id('saw-qa-title'); if (titleEl) titleEl.innerText = p.title;
    renderQaColors(p);
    qaBannerSync();   // launch → EA countdown banner; everything else → BUY 3 GET 1

    var f = getFomo(p.title);
    var vEl = id('saw-fomo-view'), sEl = id('saw-fomo-sold'), lEl = id('saw-fomo-left'),
        barEl = id('saw-fomo-bar'), row2 = id('saw-fomo-row2'), ltext = id('saw-fomo-left-text'), strip = id('saw-fomo-strip');
    if (vEl) vEl.innerText = f.view; if (sEl) sEl.innerText = f.sold;
    var colorLc = (p.colorName || '').toLowerCase();
    var isBW = colorLc.indexOf('black') > -1 || colorLc.indexOf('off white') > -1 || colorLc.indexOf('off-white') > -1 || colorLc.indexOf('white') > -1;
    if (strip) strip.style.setProperty('--saw-fomo-color', isBW ? 'rgb(37,181,62)' : '#c36a4e');

    var qtys = (p.variants || []).filter(function (v) { return v.size !== 'Default'; }).map(function (v) { return v.qty || 0; });
    var totalInv = qtys.reduce(function (a, b) { return a + b; }, 0);
    var baseline = Math.max(1, Math.floor(totalInv / (qtys.length || 1)));
    var maxCap = baseline + 20;
    function setBar(qty, picked) {
      if (!lEl || !barEl) return;
      lEl.innerText = qty;
      if (ltext) ltext.innerText = picked ? 'items left' : 'left in each size';
      barEl.style.width = Math.max(5, Math.min(100, (qty / maxCap) * 100)) + '%';
      lEl.classList.remove('saw-pop'); void lEl.offsetWidth; lEl.classList.add('saw-pop');
    }
    window['_sawSetBar_' + SID] = setBar;
    if (totalInv > 0 && row2) { row2.style.display = 'flex'; setBar(baseline, false); } else if (row2) row2.style.display = 'none';

    if (window['sawLiveInt_' + SID]) clearInterval(window['sawLiveInt_' + SID]);
    window['sawLiveInt_' + SID] = setInterval(function () {
      if (vEl) { var c = parseInt(vEl.innerText, 10); vEl.innerText = Math.max(10, c + (Math.floor(Math.random() * 7) - 3)); vEl.classList.remove('saw-pop'); void vEl.offsetWidth; vEl.classList.add('saw-pop'); }
      if (sEl && Math.random() > 0.4) { sEl.innerText = parseInt(sEl.innerText, 10) + 1; sEl.classList.remove('saw-pop'); void sEl.offsetWidth; sEl.classList.add('saw-pop'); }
    }, 3500);

    var chart = null;
    (p.tags || []).forEach(function (t) { if (CHARTS[t]) chart = CHARTS[t]; });
    var trig = id('saw-qa-chart-trigger');
    if (trig) {
      var kiwiChartId = p.kiwiId || '';
      if (kiwiChartId) trig.setAttribute('data-kiwi', kiwiChartId); else trig.removeAttribute('data-kiwi');
      if (chart) trig.setAttribute('data-img', chart); else trig.removeAttribute('data-img');
      trig.style.display = (kiwiChartId || chart) ? 'inline' : 'none';
      if (window.kwSpecs) kwSpecs(id('kw-specs'), p.specs);
      if (window.kwRate) kwRate(id('kw-rate'), p.rating, p.raters);
    }
      if (kiwiChartId) setTimeout(function () { kiwiPrefetchW(kiwiChartId); }, 60);

    var uniq = [], smap = {};
    (p.variants || []).forEach(function (v) { if (v.size !== 'Default' && !smap[v.size]) { smap[v.size] = v; uniq.push(v); } });
    uniq.sort(function (a, b) { return (sizeOrderMap[a.size] || 99) - (sizeOrderMap[b.size] || 99); });
    var selected = null;
    if (filterState.size && smap[filterState.size] && smap[filterState.size].available) selected = smap[filterState.size];
    else selected = uniq.find(function (v) { return v.available; });

    var sc = id('saw-qa-sizes');
    if (sc) {
      sc.innerHTML = uniq.map(function (v) {
        var isSel = selected && selected.id === v.id;
        return '<div class="saw-size-circ ' + (!v.available ? 'is-disabled' : '') + ' ' + (isSel ? 'is-selected' : '') + '" data-vid="' + v.id + '" data-size="' + v.size + '" data-price="' + v.price + '">' + v.size + '</div>';
      }).join('');
    }
    if (selected) selectQaSize(null, selected.id, selected.size, selected.price, true);
    else {
      var lbl = id('saw-qa-selsize'); if (lbl) lbl.innerText = 'Out of Stock';
      if (addBtn) addBtn.disabled = true; if (bnBtn) bnBtn.disabled = true;
      renderPriceBlock((qaCurrentProduct && qaCurrentProduct.price) || 0);   // sold-out launch items still show their price
    }
    var ov = id('saw-qa-overlay');
    if (ov) {
      ov.classList.add('is-visible'); lockBody();
      // Without this the media column stays unwrapped until the 900ms tick — the image lands in the
      // right-hand grid column and the offer banner never mounts (empty left column on desktop).
      if (window.__sawKwSync) {
        window.__sawKwSync();
        requestAnimationFrame(window.__sawKwSync);
        setTimeout(window.__sawKwSync, 120);
      }
    }
  }
  function closeQuickAdd() {
    var ov = id('saw-qa-overlay');
    if (ov) { ov.classList.remove('is-visible'); unlockBody(); }
    if (window['sawLiveInt_' + SID]) clearInterval(window['sawLiveInt_' + SID]);
    qaHideOffer = false;
  }
  function selectQaSize(el, vid, size, price, skipDom) {
    qaSelectedVariantId = vid;
    var setBar = window['_sawSetBar_' + SID];
    if (setBar) {
      var qty = null;
      Object.keys(allProducts).some(function (h) {
        var mv = (allProducts[h].variants || []).find(function (v) { return v.id === vid; });
        if (mv) { qty = mv.qty || 0; return true; } return false;
      });
      if (qty !== null) setBar(qty, true);
    }
    var lbl = id('saw-qa-selsize'); if (lbl) lbl.innerText = size;
    renderPriceBlock(price);
    var addBtn = id('saw-qa-add'); if (addBtn) { addBtn.disabled = false; addBtn.innerText = addLabel(); }
    if (!skipDom && el) { qsa('#saw-qa-sizes-' + SID + ' .saw-size-circ').forEach(function (c) { c.classList.remove('is-selected'); }); el.classList.add('is-selected'); }
  }
  function cartAdd(onOk, onErr) {
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: qaSelectedVariantId, quantity: 1 }] })
    }).then(function (r) { if (r.ok) onOk(); else onErr(); }).catch(onErr);
  }
  function submitQuickAdd() {
    if (!qaSelectedVariantId) return;
    var btn = id('saw-qa-add'); if (btn) { btn.innerText = 'ADDING...'; btn.disabled = true; }
    cartAdd(function () {
      if (btn) btn.innerText = 'ADDED TO BAG ✓'; if (window.kwToast) kwToast('Added to bag');
      setTimeout(function () {
        closeQuickAdd();
        window.dispatchEvent(new Event('cart:updated'));
        document.documentElement.dispatchEvent(new CustomEvent('cart:build', { bubbles: true }));
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { variant_id: qaSelectedVariantId } }));
      }, 500);
    }, function () { if (btn) { btn.innerText = 'ERROR - TRY AGAIN'; btn.disabled = false; } });
  }
  // Buy Now → GoKwik checkout directly (via window.onBuyNowClick exposed by the GoKwik script).
  // Falls back to add-to-cart + native checkout form only if GoKwik isn't loaded.
  function addLabel() { return 'ADD TO BAG'; }   // standard pair on every overview (men-flowy style)
  function bnLabel() { return 'BUY NOW'; }
  function submitBuyNow() {
    if (!qaSelectedVariantId) return;
    var bn = id('saw-qa-buynow'); if (bn) { bn.innerText = 'PROCESSING...'; bn.disabled = true; }
    var items = [{ id: parseInt(qaSelectedVariantId, 10), quantity: 1 }];
    if (typeof window.onBuyNowClick === 'function') {
      try {
        window.onBuyNowClick(bn, false, items);   // GoKwik signature: (event/element, false, lineItems[])
        setTimeout(function () { if (bn) { bn.innerText = bnLabel(); bn.disabled = false; } closeQuickAdd(); }, 800);
        return;
      } catch (err) { console.error('SAW GoKwik buynow error', err); }
    }
    // fallback — add to cart then trigger native checkout
    cartAdd(function () {
      window.dispatchEvent(new Event('cart:updated'));
      document.documentElement.dispatchEvent(new CustomEvent('cart:build', { bubbles: true }));
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      setTimeout(function () {
        var hidden = id('saw-hidden-checkout-btn');
        if (hidden) { hidden.click(); if (bn) { bn.innerText = bnLabel(); bn.disabled = false; } closeQuickAdd(); }
        else window.location.href = window.Shopify.routes.root + 'cart';
      }, 300);
    }, function () { if (bn) { bn.innerText = 'ERROR - TRY AGAIN'; bn.disabled = false; } });
  }

  /* ───────── size-chart ───────── */
  var lockScrollY = 0, bodyLockCount = 0;
  function lockBody() {
    if (++bodyLockCount > 1) return;
    lockScrollY = window.pageYOffset;
    var bs = document.body.style;
    bs.position = 'fixed'; bs.top = -lockScrollY + 'px'; bs.left = '0'; bs.right = '0'; bs.width = '100%'; bs.overflow = 'hidden';
  }
  function anyOverlayOpenW() {
    return !!document.querySelector('.saw-overlay.is-visible, [id^="saw-inline-home-"].is-visible');
  }
  function unlockBody() {
    bodyLockCount = Math.max(0, bodyLockCount - 1);
    if (bodyLockCount > 0 && anyOverlayOpenW()) return;   // self-heal: leaked counts can't freeze the page
    bodyLockCount = 0;
    var bs = document.body.style;
    bs.position = ''; bs.top = ''; bs.left = ''; bs.right = ''; bs.width = ''; bs.overflow = '';
    window.scrollTo({ top: lockScrollY, left: 0, behavior: 'instant' });
  }
  var KIWI_SRC2 = 'https://app.kiwisizing.com/web/js/dist/kiwiSizing/plugin/SizingPlugin.prod.js?v=323';
  var kiwiChartRendered = '', kiwiRowsW = {}, kiwiUnitW = 'in';
  function kiwiLsW(id) { try { var o = JSON.parse(localStorage.getItem('saadaaKiwiC:' + id) || 'null'); if (o && o.rows && o.headers && (Date.now() - o.ts) < 604800000) return { headers: o.headers, rows: o.rows }; } catch (e) {} return null; }
  function kiwiLsSaveW(id, pl) { try { localStorage.setItem('saadaaKiwiC:' + id, JSON.stringify({ ts: Date.now(), headers: pl.headers, rows: pl.rows })); } catch (e) {} }
  function kiwiScrapeW(t) {
    var headRow = t.querySelector('tr');
    if (!headRow) return null;
    var headers = Array.prototype.map.call(headRow.children, function (c) { return (c.textContent || '').trim().toUpperCase(); });
    var rows = {};
    Array.prototype.slice.call(t.querySelectorAll('tr'), 1).forEach(function (tr) {
      var cells = Array.prototype.map.call(tr.children, function (c) { return (c.textContent || '').trim(); });
      if (!cells.length) return;
      var rec = {};
      headers.forEach(function (h, i) { if (i > 0 && cells[i]) rec[h] = cells[i]; });
      rows[(cells[0] || '').toUpperCase()] = rec;
    });
    return { headers: headers.slice(1), rows: rows };
  }
  function kiwiLabelW(h) { return /LENGTH|INSEAM/i.test(h) ? 'GARMENT LENGTH' : ('IF YOUR ' + h + ' IS'); }
  /* ── sc-cards: size-guide sheet redesign (bw standard) ── */
  function kNorm(t) { return (t || '').replace(/\s+/g, ' ').trim(); }
  function kUp(t) { return kNorm(t).toUpperCase(); }
  function kiwiShortLabel(h) { return /\b(LENGTH|INSEAM)\b/i.test(h) ? 'LENGTH' : kUp(h).replace(/[^A-Z ]/g, '').trim(); }
  function scSetMode(m) {
    var bmrow = id('saw-sc-bmrow'), hint = id('saw-sc-hint'), atc = id('saw-sc-atc'), cards = id('saw-sc-cards');
    if (bmrow) bmrow.style.display = (m === 'cards') ? 'flex' : 'none';
    if (hint) hint.style.display = (m === 'cards') ? '' : 'none';
    if (atc) atc.style.display = (m === 'cards') ? '' : 'none';
    if (cards && m !== 'cards') cards.innerHTML = '';
  }
  function scAtcSync() {
    var btn = id('saw-sc-atc'); if (!btn) return;
    var sel = qs('#saw-sc-cards-' + SID + ' .saw-scc-row.is-selected');
    if (sel) { btn.disabled = false; btn.textContent = 'ADD TO BAG · ' + sel.getAttribute('data-size'); }
    else { btn.disabled = true; btn.textContent = 'SELECT A SIZE'; }
  }
  function renderSizeTable(payload) {
    var cont = id('saw-sc-cards'), unit = id('saw-sc-unit'), img = id('saw-sc-img');
    if (!cont) return false;
    if (!payload || !payload.rows || !Object.keys(payload.rows).length) { cont.innerHTML = ''; if (unit) unit.style.display = 'none'; return false; }
    var allH = (payload.headers || []).map(function (h) { return (h || '').trim(); }).filter(function (h) { return h && kUp(h) !== 'SIZE'; });
    var filtered = allH.filter(function (h) { return Object.keys(payload.rows).some(function (sz) { return (payload.rows[sz][h] || '').trim().length > 0; }); });
    var priority = [/\bWAIST\b/i, /\bBUST\b/i, /\bCHEST\b/i, /\bHIPS?\b/i, /\b(LENGTH|INSEAM)\b/i];
    filtered.sort(function (a, b) { var ia = priority.findIndex(function (rx) { return rx.test(a); }), ib = priority.findIndex(function (rx) { return rx.test(b); }); return (ia === -1 ? 999 : ia) - (ib === -1 ? 999 : ib); });
    var cols = filtered.slice(0, 3);
    var p = qaCurrentProduct || {};
    var vmap = {};
    (p.variants || []).forEach(function (v) { vmap[kUp(v.size)] = v; });
    var selSize = '';
    (p.variants || []).some(function (v) { if (String(v.id) === String(qaSelectedVariantId)) { selSize = kUp(v.size); return true; } return false; });
    cont.innerHTML = Object.keys(payload.rows).map(function (sz) {
      var rec = payload.rows[sz] || {};
      var v = vmap[kUp(sz)];
      var dis = !v || !v.available;
      var sel = !dis && kUp(sz) === selSize;
      return '<div class="saw-scc-row' + (sel ? ' is-selected' : '') + (dis ? ' is-disabled' : '') + '" data-size="' + sz + '"'
        + (v ? ' data-vid="' + v.id + '" data-price="' + v.price + '"' : '') + '>'
        + '<span class="saw-scc-radio"></span><span class="saw-scc-size">' + sz + '</span>'
        + '<span class="saw-scc-cols" style="grid-template-columns:repeat(' + (cols.length || 1) + ',1fr)">'
        + cols.map(function (h) { return '<span class="saw-scc-col"><span class="saw-scc-lab">' + kiwiShortLabel(h) + '</span><span class="saw-scc-val sc-val" data-base="' + (rec[h] || '').replace(/"/g, '&quot;') + '">' + (rec[h] || '') + '</span></span>'; }).join('')
        + '</span></div>';
    }).join('');
    if (unit) unit.style.display = cols.length ? 'flex' : 'none';
    if (img) img.style.display = 'none';
    kiwiUnitW = 'in';
    qsa('.saw-sc-unit-btn', id('saw-sc-unit')).forEach(function (b) { b.classList.toggle('active', b.getAttribute('data-unit') === 'in'); });
    scAtcSync();
    return true;
  }
  function updateSizeUnits() {
    qsa('#saw-sc-cards-' + SID + ' .sc-val').forEach(function (td) {
      var base = td.getAttribute('data-base'); if (base == null) return;
      td.textContent = kiwiUnitW === 'cm' ? base.replace(/\d+(\.\d+)?/g, function (m) { return (parseFloat(m) * 2.54).toFixed(1).replace(/\.0$/, ''); }).replace(/["″]/g, '') : base;
    });
  }
  function kiwiTableHtmlW(pl, title) {
    var head = '<div class="kw2-head"><div class="kw2-title">' + (title || 'Size Chart') + '</div><div class="kw2-sub">SIZE CHARTS</div></div>';
    var unit = '<div class="kw2-unit"><span class="kw2-ub' + (kiwiUnitW === 'in' ? ' on' : '') + '" data-u="in">INCH</span><span class="kw2-ub' + (kiwiUnitW === 'cm' ? ' on' : '') + '" data-u="cm">CM</span></div>';
    var conv = function (v) { return kiwiUnitW === 'cm' ? v.replace(/\d+(\.\d+)?/g, function (m) { return (parseFloat(m) * 2.54).toFixed(1).replace(/\.0$/, ''); }) : v; };
    var html = '<table class="kw2-table"><thead><tr><th>SELECT SIZE</th>' + pl.headers.map(function (h) { return '<th>' + kiwiLabelW(h) + '</th>'; }).join('') + '</tr></thead><tbody>';
    Object.keys(pl.rows).forEach(function (sz) {
      html += '<tr><td class="kw2-sz">' + sz + '</td>' + pl.headers.map(function (h) { return '<td>' + conv(pl.rows[sz][h] || '') + '</td>'; }).join('') + '</tr>';
    });
    html += '</tbody></table><div class="kw2-note">NOTE - This Size chart is according to the body measurement.</div>';
    return head + unit + html;
  }
  function kiwiEnrichChipsW(pl) {
    if (window.kwSizeLabel) kwSizeLabel(id('saw-qa-overlay'), pl);
    var cont = id('saw-qa-sizes'); if (!cont) return;
    var first = pl.headers[0];
    Array.prototype.forEach.call(cont.querySelectorAll('.saw-size-circ'), function (el) {
      var sz = (el.getAttribute('data-size') || el.textContent || '').trim().toUpperCase().split('\n')[0];
      var rec = pl.rows[sz];
      if (rec && rec[first] && !el.querySelector('.kw2-range')) {
        var sm = document.createElement('small'); sm.className = 'kw2-range'; sm.textContent = rec[first];
        el.appendChild(sm); el.classList.add('kw2-has-range');
      }
    });
  }
  function kiwiPresentW(chartId, mount) {
    var pl = kiwiRowsW[chartId]; if (!pl) return;
    kiwiEnrichChipsW(pl);
    var scMount = id('saw-sc-kiwi'), ov = id('saw-sc-overlay');
    if (mount === scMount) {   // chart sheet: upgrade raw Kiwi render to row-cards when a scraped payload exists
      if (renderSizeTable(pl)) {
        mount.style.display = 'none';
        scSetMode('cards');
        var scModal2 = ov && qs('.saw-sc-modal', ov); if (scModal2) scModal2.classList.remove('is-kiwi');
        return;
      }
      scSetMode('kiwi');
      mount.style.display = 'block';
    }
    var title = (id('saw-qa-title') || {}).textContent || '';
    mount.innerHTML = kiwiTableHtmlW(pl, title);
    Array.prototype.forEach.call(mount.querySelectorAll('.kw2-ub'), function (b) {
      b.addEventListener('click', function () { kiwiUnitW = b.getAttribute('data-u'); kiwiPresentW(chartId, mount); });
    });
  }
  function kiwiPrefetchW(chartId) {
    if (kiwiRowsW[chartId]) { kiwiEnrichChipsW(kiwiRowsW[chartId]); return; }
    var kwlsW = kiwiLsW(chartId); if (kwlsW) { kiwiRowsW[chartId] = kwlsW; kiwiEnrichChipsW(kwlsW); return; }
    var ov = id('saw-sc-overlay');
    if (ov && ov.classList.contains('is-visible')) return;
    var host = document.getElementById('kw-prefetch-host');
    if (!host) { host = document.createElement('div'); host.id = 'kw-prefetch-host'; host.style.cssText = 'position:absolute;left:-9999px;top:-9999px;width:1px;height:1px;overflow:hidden;'; document.body.appendChild(host); }
    renderKiwiChartRaw(chartId, host);
  }
  function renderKiwiChartRaw(chartId, mount) {
    if (kiwiRowsW[chartId]) { kiwiPresentW(chartId, mount); return; }
    var kwlsPW = kiwiLsW(chartId); if (kwlsPW) { kiwiRowsW[chartId] = kwlsPW; kiwiPresentW(chartId, mount); return; }
    if (kiwiChartRendered === chartId && mount.children.length) return;
    kiwiChartRendered = chartId;
    var stale = document.getElementById('KiwiSizingChart');
    if (stale && stale.parentNode) stale.parentNode.removeChild(stale);
    mount.innerHTML = '<div id="KiwiSizingChart" data-sizing-id="' + chartId + '" data-display-mode="0"><div class="saw-kiwi-loading">Loading size chart\u2026</div></div>';
    var kicked = false, tries = 0;
    (function kick() {
      if (!kicked) {
        if (typeof window.loadKiwiSizingChart === 'function') { kicked = true; try { window.loadKiwiSizingChart(); } catch (e) {} }
        else if (!document.getElementById('saw-kiwi-script')) {
          var sc = document.createElement('script'); sc.id = 'saw-kiwi-script'; sc.async = true;
          sc.src = KIWI_SRC2;
          document.body.appendChild(sc);
        }
      }
      var t = mount.querySelector('.ks-table');
      if (t) {
        var pl = kiwiScrapeW(t);
        if (pl && Object.keys(pl.rows).length) { kiwiRowsW[chartId] = pl; kiwiLsSaveW(chartId, pl); kiwiPresentW(chartId, mount); return; }
      }
      if (++tries < 24) setTimeout(kick, 250);
    })();
  }
  function openSizeChart() {
    var trig = id('saw-qa-chart-trigger'); if (!trig) return;
    var ov = id('saw-sc-overlay'); if (!ov) return;
    var titleEl = id('saw-sc-title'); if (titleEl && qaCurrentProduct) titleEl.innerText = qaCurrentProduct.title || 'Size Chart';
    var img = id('saw-sc-img'), mount = id('saw-sc-kiwi'), unit = id('saw-sc-unit');
    var kiwiChartId = trig.getAttribute('data-kiwi') || '';
    var url = trig.getAttribute('data-img') || '';
    var scHead = qs('.saw-sc-head', ov);
    var scModal = qs('.saw-sc-modal', ov);
    if (mount) mount.style.display = 'none';
    if (scModal) scModal.classList.remove('is-kiwi');
    if (kiwiChartId && mount) {
      if (scHead) scHead.style.display = '';
      scSetMode('kiwi');
      if (unit) unit.style.display = 'none';
      if (img) img.style.display = 'none';
      if (scModal) scModal.classList.add('is-kiwi');
      mount.style.display = 'block';   // before render: cached payloads flip to cards synchronously via kiwiPresentW
      renderKiwiChartRaw(kiwiChartId, mount);
    } else if (url && img) {
      if (scHead) scHead.style.display = 'none';
      scSetMode('img');
      if (unit) unit.style.display = 'none';
      img.src = url; img.style.display = 'block';
    }
    else return;
    lockBody();
    ov.classList.add('is-visible');
  }
  function closeSizeChart() { var ov = id('saw-sc-overlay'); if (ov) ov.classList.remove('is-visible'); unlockBody(); }

  /* ───────── filter modal ───────── */
  function visibleProductsForFilter() {
    var out = [];
    categories.forEach(function (cat) {
      if (tempFilterGroup && cat.group !== tempFilterGroup) return;   // respect the modal's category toggle while building lists
      cat.products.forEach(function (p) { out.push(p); });
    });
    return out;
  }
  function renderFilterGroup() {
    var cont = id('saw-filter-group'); if (!cont) return;
    qsa('.saw-fgroup-btn', cont).forEach(function (b) {
      var g = b.getAttribute('data-fgroup');
      b.classList.toggle('is-selected', (tempFilterGroup === null && g === 'all') || g === tempFilterGroup);
    });
  }
  function renderFilterSizes() {
    var cont = id('saw-filter-sizes'); if (!cont) return;
    var all = {};
    visibleProductsForFilter().forEach(function (p) { p.sizes.forEach(function (s) { all[s] = true; }); });
    var arr = Object.keys(all).sort(function (a, b) { var ra = sizeOrderMap[a] || 99, rb = sizeOrderMap[b] || 99; return ra !== rb ? ra - rb : a.localeCompare(b); });
    cont.innerHTML = arr.map(function (s) { return '<div class="saw-size-circ ' + (tempFilterSize === s ? 'is-selected' : '') + '" data-fsize="' + s + '">' + s + '</div>'; }).join('');
  }
  var SWATCH_MAP = {
    'black':'#1a1a1a','jet black':'#0f0f0f','white':'#ffffff','off white':'#f3efe6','offwhite':'#f3efe6','ivory':'#f5f0e1','cream':'#f3ead6','ecru':'#e6dcc8','beige':'#e7d9c4','sand':'#e4d5b7','tan':'#d2b48c','khaki':'#c3b091','camel':'#c19a6b','brown':'#6b4f3a','coffee':'#4b3621','chocolate':'#3f2a1d','mocha':'#6f4e37',
    'grey':'#9e9e9e','gray':'#9e9e9e','charcoal':'#36454f','slate':'#5b6770','silver':'#c0c0c0','stone':'#b8ada0',
    'navy':'#1f2a44','blue':'#2f5fd0','royal blue':'#2b4cdb','cobalt':'#2949b8','sky':'#7ec8e3','sky blue':'#7ec8e3','powder blue':'#b6d3e6','denim':'#3b5a86','teal':'#008080','turquoise':'#30d5c8','aqua':'#5fc9c9',
    'green':'#2e7d32','olive':'#708238','sage':'#9caf88','sage green':'#9caf88','mint':'#aee1c3','emerald':'#0f7d54','forest':'#1b4332','bottle green':'#0b3d2e','pista':'#b5c98f','pistachio':'#b5c98f','lime':'#9bbf3b',
    'red':'#d0312d','maroon':'#7b1e26','wine':'#722f37','burgundy':'#5c1a2b','rust':'#b7410e','terracotta':'#c66b3d','brick':'#9c4a3c','coral':'#ff7f50',
    'pink':'#f4a6c0','rose':'#d77b8c','blush':'#e8b7bd','baby pink':'#f7c6d2','fuchsia':'#c2185b','magenta':'#c71585','peach':'#ffcba4','salmon':'#fa8072',
    'orange':'#ef6c2f','mustard':'#d4a017','yellow':'#f2c12e','gold':'#d4af37','lemon':'#f6e27a',
    'purple':'#6a3d9a','lavender':'#b497bd','lilac':'#c8a2c8','mauve':'#a6788e','plum':'#6e3b5c',
    'multi':'linear-gradient(135deg,#e74c3c,#f39c12,#2ecc71,#3498db,#9b59b6)','multicolor':'linear-gradient(135deg,#e74c3c,#f39c12,#2ecc71,#3498db,#9b59b6)','multicolour':'linear-gradient(135deg,#e74c3c,#f39c12,#2ecc71,#3498db,#9b59b6)','printed':'linear-gradient(135deg,#e74c3c,#f39c12,#2ecc71,#3498db,#9b59b6)','print':'linear-gradient(135deg,#e74c3c,#f39c12,#2ecc71,#3498db,#9b59b6)'
  };
  function swatchColor(name) {
    var key = (name || '').toLowerCase().trim();
    if (!key) return null;
    if (SWATCH_MAP[key]) return SWATCH_MAP[key];
    // longest known colour word contained in the name (e.g. "dusty sage green" -> "sage green")
    var hit = null, hitLen = 0;
    Object.keys(SWATCH_MAP).forEach(function (k) {
      if (k.length > hitLen && key.indexOf(k) !== -1) { hit = SWATCH_MAP[k]; hitLen = k.length; }
    });
    return hit;
  }
  function renderFilterFamilies() {
    var cont = id('saw-filter-fams'); if (!cont) return;
    var have = {};
    visibleProductsForFilter().forEach(function (p) { (p.tags || []).forEach(function (t) { have[t] = 1; }); });
    var groups = FAMILY_GROUPS.filter(function (g) { return have[g[0].toLowerCase()]; });
    var wrap = cont.parentNode;
    if (wrap) wrap.style.display = groups.length ? '' : 'none';
    cont.innerHTML = groups.map(function (g) {
      return '<button type="button" class="saw-fam' + (tempFilterFamily.indexOf(g[0]) !== -1 ? ' on' : '') + '" data-fam="' + g[0] + '">'
        + '<span class="saw-fam-sw" style="background:' + g[1] + '"></span>' + g[0] + '</button>';
    }).join('');
  }
  function renderFilterColors() {
    var cont = id('saw-filter-colors'); if (!cont) return;
    var map = {};
    visibleProductsForFilter().forEach(function (p) {
      var nm = (p.colorName || '').trim(); if (!nm) return;
      var key = nm.toLowerCase();
      if (!map[key]) map[key] = { name: nm, image: p.image || '', swatch: p.swatch || '' };
    });
    var keys = Object.keys(map).sort(function (a, b) { return map[a].name.localeCompare(map[b].name); });
    cont.innerHTML = keys.map(function (key) {
      var c = map[key], fill = c.swatch || swatchColor(c.name);   // metafield rgb/hex first, then name map
      var dot = fill ? 'background:' + fill + ';'
        : (c.image ? 'background-image:url(' + c.image + ');background-size:cover;background-position:center;' : 'background:#ccc;');
      var sel = tempFilterColors.indexOf(key) !== -1 ? ' is-selected' : '';
      return '<div class="saw-swatch' + sel + '" data-fcolor="' + key + '" title="' + c.name.replace(/"/g, '&quot;') + '">'
        + '<span class="saw-swatch-dot" style="' + dot + '"></span></div>';
    }).join('');
    var nameEl = id('saw-color-selname');
    if (nameEl) {
      var selNames = tempFilterColors.map(function (k) { return map[k] ? map[k].name : null; }).filter(Boolean);
      nameEl.innerText = selNames.length ? (' : ' + selNames.join(', ')) : '';
    }
    initSwatchNav();
  }
  function initSwatchNav() {
    var track = id('saw-filter-colors'); if (!track) return;
    var wrap = track.closest('.saw-swatch-carousel'); if (!wrap) return;
    var leftBtn = qs('.saw-sw-nav--left', wrap), rightBtn = qs('.saw-sw-nav--right', wrap), bar = qs('.saw-sw-progress-bar', wrap);
    function update() {
      var max = track.scrollWidth - track.clientWidth;
      if (bar) bar.style.width = (max <= 0 ? 100 : Math.min(100, Math.max(20, (track.scrollLeft / max) * 100))) + '%';
      if (leftBtn && rightBtn) {
        if (max <= 2) { leftBtn.classList.remove('is-visible'); rightBtn.classList.remove('is-visible'); return; }
        leftBtn.classList.toggle('is-visible', track.scrollLeft > 2);
        rightBtn.classList.toggle('is-visible', track.scrollLeft < max - 2);
      }
    }
    function step(dir) { track.scrollBy({ left: dir * Math.round(track.clientWidth * 0.8), behavior: 'smooth' }); }
    if (!track._sawSwBound) {
      track._sawSwBound = true;
      var rafPending = false;   // one measure per frame — re-measuring on every scroll event made phone swipes janky
      track.addEventListener('scroll', function () { if (rafPending) return; rafPending = true; requestAnimationFrame(function () { rafPending = false; update(); }); }, { passive: true });
      window.addEventListener('resize', update);
      if (leftBtn) leftBtn.addEventListener('click', function () { step(-1); });
      if (rightBtn) rightBtn.addEventListener('click', function () { step(1); });
    }
    setTimeout(update, 50);
  }
  function openFilter() {
    tempFilterSize = filterState.size;
    tempFilterColors = filterState.colors.slice(); tempFilterFamily = (filterState.family || []).slice();
    tempFilterGroup = activeGroup;
    renderFilterGroup();
    renderFilterSizes();
    renderFilterColors(); renderFilterFamilies();
    var ov = id('saw-filter-overlay'); if (ov) { ov.classList.add('is-visible'); lockBody(); }
  }
  function closeFilter() { var ov = id('saw-filter-overlay'); if (ov) { ov.classList.remove('is-visible'); unlockBody(); } }
  function applyFilter() {
    filterState.size = tempFilterSize;
    updateFfSizeBtn();
    filterState.colors = tempFilterColors.slice(); filterState.family = tempFilterFamily.slice();
    var minI = id('saw-price-min-input'), maxI = id('saw-price-max-input');
    filterState.minPrice = minI ? (parseInt(minI.value, 10) || 0) : 0;
    filterState.maxPrice = maxI ? (parseInt(maxI.value, 10) || maxPriceLimit) : maxPriceLimit;
    activeGroup = tempFilterGroup;   // apply the modal's category toggle
    setActiveToggle();               // keep the bottom-bar toggle in sync
    updateFilterLabel();
    applyGroupVisibility();   // re-evaluate visibility so empty categories + roundels hide
    closeFilter();
  }
  function clearFilter() {
    tempFilterSize = null;
    tempFilterColors = []; tempFilterFamily = [];
    tempFilterGroup = null;
    activeGroup = null;
    setActiveToggle();
    renderFilterGroup();
    filterState.size = null;
    updateFfSizeBtn();
    filterState.colors = []; filterState.family = [];
    filterState.minPrice = 0;
    filterState.maxPrice = maxPriceLimit;
    var minR = id('saw-price-min-range'), maxR = id('saw-price-max-range'), minI = id('saw-price-min-input'), maxI = id('saw-price-max-input');
    if (minR) minR.value = 0;
    if (maxR) maxR.value = maxPriceLimit;
    if (minI) minI.value = 0;
    if (maxI) maxI.value = maxPriceLimit;
    if (window['_sawUpdateTrack_' + SID]) window['_sawUpdateTrack_' + SID]();
    renderFilterSizes();
    renderFilterColors(); renderFilterFamilies();
    updateFilterLabel();
    applyGroupVisibility();
  }
  /* ── floating bar: SIZE dropdown (All Linen behaviour) ── */
  function ffBar() { return id('saw-ffilter'); }
  function renderFfSizes() {
    var grid = id('saw-ff-dd-grid'); if (!grid) return;
    var all = {};
    visibleProductsForFilter().forEach(function (p) { (p.sizes || []).forEach(function (sz) { all[sz] = true; }); });
    var arr = Object.keys(all).sort(function (a, b) { var ra = sizeOrderMap[a] || 99, rb = sizeOrderMap[b] || 99; return ra !== rb ? ra - rb : a.localeCompare(b); });
    grid.innerHTML = arr.map(function (sz) {
      return '<button type="button" class="saw-ff-sz' + (filterState.size === sz ? ' is-selected' : '') + '" data-ff-sz="' + sz + '">' + sz + '</button>';
    }).join('') || '<div class="saw-loading" style="padding:6px 2px;">No sizes</div>';
  }
  function updateFfSizeBtn() {
    var btn = id('saw-ff-size'); if (!btn || !btn.firstChild) return;
    btn.classList.toggle('is-active', !!filterState.size);
    btn.firstChild.nodeValue = filterState.size ? filterState.size + ' ' : 'Size ';
  }
  function closeFfDd() { var b = ffBar(); if (b) b.classList.remove('dd-open'); }
  function toggleFfDd() {
    var b = ffBar(); if (!b) return;
    if (b.classList.contains('dd-open')) { closeFfDd(); return; }
    renderFfSizes();
    b.classList.add('dd-open');
  }
  function pickFfSize(sz) {
    filterState.size = (filterState.size === sz) ? null : sz;
    updateFfSizeBtn();
    updateFilterLabel();
    applyGroupVisibility();   // re-renders the visible rows against the new size
    closeFfDd();
  }
  function updateFilterLabel() {
    var labelEl = qs('[data-saw-filter-label]', root);
    if (!labelEl) return;
    var parts = [];
    if (filterState.size) parts.push(filterState.size);
    if (filterState.minPrice > 0 || filterState.maxPrice < maxPriceLimit) parts.push('₹' + filterState.minPrice + '-' + filterState.maxPrice);
    labelEl.innerText = parts.length ? ' : ' + parts.join(', ') : '';
  }
  function setupSlider() {
    var minR = id('saw-price-min-range'), maxR = id('saw-price-max-range'), minI = id('saw-price-min-input'), maxI = id('saw-price-max-input'), track = id('saw-price-track');
    function updateTrack() {
      if (!minR || !maxR || !track) return;
      var lo = parseInt(minR.value, 10), hi = parseInt(maxR.value, 10), lim = parseInt(maxR.max, 10) || 1;
      if (lo > hi - 10) { lo = hi - 10; minR.value = lo; }
      track.style.left = (lo / lim * 100) + '%';
      track.style.width = ((hi - lo) / lim * 100) + '%';
      if (minI) minI.value = lo; if (maxI) maxI.value = hi;
    }
    function fromInputs() {
      if (!minI || !maxI || !maxR) return;
      var lo = parseInt(minI.value, 10) || 0, hi = parseInt(maxI.value, 10) || parseInt(maxR.max, 10), lim = parseInt(maxR.max, 10);
      if (lo < 0) lo = 0; if (hi > lim) hi = lim; if (lo > hi - 10) lo = hi - 10;
      if (minR) minR.value = lo; if (maxR) maxR.value = hi; updateTrack();
    }
    if (minR && maxR && minI && maxI) {
      minR.addEventListener('input', updateTrack); maxR.addEventListener('input', updateTrack);
      minI.addEventListener('change', fromInputs); maxI.addEventListener('change', fromInputs);
    }
    window['_sawUpdateTrack_' + SID] = updateTrack;
  }

  /* ───────── delegated events ───────── */
  root.addEventListener('click', function (e) {
    var roundel = e.target.closest('.saw-roundel');
    if (roundel) {
      var slug = roundel.getAttribute('data-cat');
      manualLockUntil = Date.now() + 1000;
      setActiveRoundel(slug);
      nclSetUrl('category', slug);
      var target = document.getElementById('saw-cat-' + slug + '-' + SID);
      if (target) { var pos = target.getBoundingClientRect().top + window.pageYOffset - (getHeaderHeight() + stickyHeight()) + 2; window.scrollTo({ top: pos, behavior: 'smooth' }); }
      return;
    }
     var card = e.target.closest('.p-card');
     var _root = document.getElementById('saw-' + SID);
     if (card && _root && _root.contains(card)) {
     var frameA = e.target.closest('a.p-frame');
     if (frameA) { window.location.href = frameA.getAttribute('href'); return; }   // sibling colour frame → that colour
     var pick3Link = card.getAttribute('data-pick3-link');
    if (pick3Link) { window.location.href = pick3Link; return; }
    if (CARD_CLICK === 'pdp') {   // 2026-08-10: setting-driven — every card goes straight to its PDP
      var pdpP = allProducts[decodeURIComponent(card.getAttribute('data-handle'))];
      if (pdpP && pdpP.link) { window.location.href = pdpP.link; return; }
    }
    openQuickAdd(decodeURIComponent(card.getAttribute('data-handle')), !!card.closest('[data-pair-it-with]'));
}
  });

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t.id === 'saw-qa-overlay-' + SID) closeQuickAdd();
    if (t.id === 'saw-sc-overlay-' + SID) closeSizeChart();
    if (t.id === 'saw-filter-overlay-' + SID) closeFilter();
    if (t.closest('[data-saw-close-qa]')) closeQuickAdd();
    if (t.closest('[data-saw-copy]')) gbwCopy(t.closest('[data-saw-copy]'));
    var _own = function (el) { if (!el) return false; var s = el.closest('[data-section]'); if (s) return s.getAttribute('data-section') === SID; var r = document.getElementById('saw-' + SID); return !!(r && r.contains(el)); };
    if (_own(t.closest('[data-saw-atc]'))) submitQuickAdd();
    if (_own(t.closest('[data-saw-buynow]'))) submitBuyNow();
    if (_own(t.closest('[data-saw-open-chart]'))) openSizeChart();
    if (_own(t.closest('[data-saw-close-chart]'))) closeSizeChart();
    var sizeCirc = t.closest('#saw-qa-sizes-' + SID + ' .saw-size-circ');
    if (sizeCirc && !sizeCirc.classList.contains('is-disabled')) selectQaSize(sizeCirc, sizeCirc.getAttribute('data-vid'), sizeCirc.getAttribute('data-size'), parseFloat(sizeCirc.getAttribute('data-price')));
    var unitBtn = t.closest('#saw-sc-unit-' + SID + ' .saw-sc-unit-btn');
    if (unitBtn && !unitBtn.classList.contains('active')) {
      qsa('#saw-sc-unit-' + SID + ' .saw-sc-unit-btn').forEach(function (b) { b.classList.remove('active'); });
      unitBtn.classList.add('active');
      kiwiUnitW = unitBtn.getAttribute('data-unit');
      updateSizeUnits();
    }
    var sccRow = t.closest('#saw-sc-cards-' + SID + ' .saw-scc-row');
    if (sccRow && !sccRow.classList.contains('is-disabled') && sccRow.getAttribute('data-vid')) {
      qsa('#saw-sc-cards-' + SID + ' .saw-scc-row').forEach(function (r) { r.classList.remove('is-selected'); });
      sccRow.classList.add('is-selected');
      var chip = qsa('#saw-qa-sizes-' + SID + ' .saw-size-circ').filter(function (c) { return kUp(c.getAttribute('data-size')) === kUp(sccRow.getAttribute('data-size')); })[0];
      selectQaSize(chip || null, sccRow.getAttribute('data-vid'), sccRow.getAttribute('data-size'), parseFloat(sccRow.getAttribute('data-price') || '0'));
      scAtcSync();
    }
    if (t.closest('#saw-sc-atc-' + SID) && qaSelectedVariantId) { closeSizeChart(); submitQuickAdd(); }
    var qaColor = t.closest('[data-qa-color]');
    if (qaColor) { openQuickAdd(decodeURIComponent(qaColor.getAttribute('data-qa-color')), qaHideOffer); return; }
    if (t.closest('[data-saw-open-filter]')) openFilter();
    if (t.closest('[data-saw-close-filter]')) closeFilter();
    if (t.closest('[data-saw-apply-filter]')) applyFilter();
    if (t.closest('[data-saw-clear-filter]')) clearFilter();
    var fGroup = t.closest('#saw-filter-group-' + SID + ' .saw-fgroup-btn');
    if (fGroup) { var g = fGroup.getAttribute('data-fgroup'); tempFilterGroup = (g === 'all') ? null : g; renderFilterGroup(); renderFilterSizes(); renderFilterColors(); renderFilterFamilies(); }
    if (t.closest('[data-saw-ff-size]')) { toggleFfDd(); return; }
    var ffSz = t.closest('[data-ff-sz]');
    if (ffSz) { pickFfSize(ffSz.getAttribute('data-ff-sz')); return; }
    if (!t.closest('#saw-ff-dd-' + SID)) closeFfDd();
    var fSize = t.closest('#saw-filter-sizes-' + SID + ' .saw-size-circ');
    if (fSize) { var s = fSize.getAttribute('data-fsize'); tempFilterSize = (tempFilterSize === s) ? null : s; renderFilterSizes(); }
    var fFam = t.closest('#saw-filter-fams-' + SID + ' .saw-fam');
    if (fFam) { var fv = fFam.getAttribute('data-fam'); var fvi = tempFilterFamily.indexOf(fv); if (fvi === -1) tempFilterFamily.push(fv); else tempFilterFamily.splice(fvi, 1); renderFilterFamilies(); }
    var fColor = t.closest('#saw-filter-colors-' + SID + ' .saw-swatch');
    if (fColor) {
      var ck = fColor.getAttribute('data-fcolor');
      var ci = tempFilterColors.indexOf(ck);
      if (ci === -1) tempFilterColors.push(ck); else tempFilterColors.splice(ci, 1);
      renderFilterColors(); renderFilterFamilies();
    }
  });

  window.addEventListener('scroll', function () { handleSticky(); syncSpy(); }, { passive: true });
  window.addEventListener('resize', function () { handleSticky(); syncSpy(); });
  document.addEventListener('scroll', function (e) {
    var tgt = e.target;
    if (tgt && tgt.nodeType === 1 && tgt.closest && (tgt.closest('.saw-roundel-row') || tgt.closest('.saw-track'))) return; // ignore the horizontal scrollers (roundel nav + card rows)
    handleSticky(); syncSpy();
  }, true); // capture: catches vertical scroll in custom containers

  /* ───────── init ───────── */
  var PRELAUNCH_FP = C.prelaunch_epoch;
  PRELAUNCH_FP = String(PRELAUNCH_FP).replace(/[^0-9]/g, '').slice(0, 20);
  var CACHE_TTL = 600000; // 10 min
  function cacheKey() { return 'saw_cache_v13_' + COLLECTION + (PRELAUNCH_FP ? '_p' + PRELAUNCH_FP : ''); }
  function cacheReadRaw(key) {
    try { return localStorage.getItem(key) || sessionStorage.getItem(key); } catch (e) { try { return sessionStorage.getItem(key); } catch (x) { return null; } }
  }
  function cacheWriteRaw(key, value) {
    try { localStorage.setItem(key, value); return; } catch (e) { try { sessionStorage.setItem(key, value); } catch (x) {} }
  }
  function productListKey(list) { return (list || []).map(function (p) { return p.handle; }).join('|'); }

  function readCache() {
    try { var r = cacheReadRaw(cacheKey()); if (!r) return null; return JSON.parse(r).p; } catch (e) { return null; }
  }
  function writeCache(prods) {
    cacheWriteRaw(cacheKey(), JSON.stringify({ t: Date.now(), p: prods }));
  }
  /* ── launch fetch: one store-wide Storefront tag query, shared by both genders ── */
  /* prices are BAKED into cached pools at normalize time — fingerprint the overrides into the
     cache keys so a settings price change busts the cache instantly instead of after TTL */
  var PRICE_FP = (function () { var s = ''; for (var k in LAUNCH_PRICES) s += k + LAUNCH_PRICES[k]; s = s ? '_' + s.replace(/[^A-Za-z0-9]/g, '') : ''; return s + (PRELAUNCH_FP ? '_p' + PRELAUNCH_FP : ''); })();
  var LAUNCH_CACHE_KEY = 'ncl_launch_v4_' + ALL_CODES.join('_') + PRICE_FP;
  /* ── Pick-Any-3 handle-fetched cards (single products, injected into specific launch rows) ── */
var PICK3_HANDLES = {
  SMCTS: 'pick-any-3-men-tailored-cotton-shorts',
  SMCCP: 'pick-any-3-men-cotton-chinos'
};
var pick3Products = {};   // code -> normalized product
var PICK3_CACHE_KEY = 'ncl_pick3_v1_' + Object.keys(PICK3_HANDLES).map(function (c) { return c + '_' + PICK3_HANDLES[c]; }).join('_') + PRICE_FP;
function fetchPick3() {
  var codes = Object.keys(PICK3_HANDLES).filter(function (c) { return PICK3_HANDLES[c]; });
  if (!codes.length) return Promise.resolve(false);
  try {
    var cached = cacheReadRaw(PICK3_CACHE_KEY);
    if (cached) {
      var saved = JSON.parse(cached);
      pick3Products = saved.p || {};
      if (Date.now() - saved.t <= CACHE_TTL) return Promise.resolve(false);
    }
  } catch (e) {}
  var previousKey = codes.map(function (c) { return pick3Products[c] ? pick3Products[c].handle : ''; }).join('|');
  var queries = codes.map(function (c, i) {
    return 'p' + i + ': product(handle: "' + PICK3_HANDLES[c] + '") {' + NODE_FIELDS + ' }';
  }).join(' ');
  return gql('{ ' + queries + ' }').then(function (j) {
    var d = j && j.data; if (!d) return false;
    codes.forEach(function (c, i) {
      var node = d['p' + i];
if (node) {
  var p = normalize(node, true);
  p.launchCode = c;
  p.isPick3 = true;
  p.colorName = '';              // blank — subtitle shows only the size range, no colour word
  p.siblingGids = [1, 2, 3, 4];  // → "Available in 4+ colours"
      pick3Products[c] = p;
}
    });
    cacheWriteRaw(PICK3_CACHE_KEY, JSON.stringify({ t: Date.now(), p: pick3Products }));
    return codes.map(function (c) { return pick3Products[c] ? pick3Products[c].handle : ''; }).join('|') !== previousKey;
  }).catch(function (err) { console.error('SAW pick3 fetch', err); return false; });
}
/* ── Co-ord sets (2026-08-29): Fly-Bundle parent products, fetched by handle and shown as their
   own carousel row, pinned just before Top Rated. They carry no style code and live in no launch
   collection, so the tag fetch above can never see them — the handle list is the whole source. ── */
var COORD_HANDLES = (C.coord_handles || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
var COORD_LABEL   = C.coord_label || 'Co-ord Sets';
var COORD_GENDER  = (C.coord_gender || 'women').toLowerCase();
var COORD_SIZES   = C.coord_sizes || '';
var COORD_IMAGE   = C.coord_image || '';
var coordProducts = [];
var COORD_CACHE_KEY = 'ncl_coord_v1_' + COORD_HANDLES.join('_') + PRICE_FP;
function coordColour(title) {   // "Better Cotton Grey Co-Ord Set" → "Grey" (bundle parents have no colour metafield)
  var m = /(black|white|grey|gray|green|pink|blue|beige|brown|maroon|yellow|purple|red|ecru|olive|navy)/i.exec(title || '');
  return m ? m[1].charAt(0).toUpperCase() + m[1].slice(1).toLowerCase() : '';
}
function fetchCoords() {
  if (!COORD_HANDLES.length) { coordProducts = []; return Promise.resolve(false); }
  try {
    var r = cacheReadRaw(COORD_CACHE_KEY);
    if (r) { var o = JSON.parse(r); coordProducts = o.p || []; if (Date.now() - o.t <= CACHE_TTL) return Promise.resolve(false); }
  } catch (e) {}
  var previousKey = productListKey(coordProducts);
  var queries = COORD_HANDLES.map(function (h, i) { return 'c' + i + ': product(handle: "' + h + '") {' + NODE_FIELDS + ' }'; }).join(' ');
  return gql('{ ' + queries + ' }').then(function (j) {
    var d = j && j.data; if (!d) return false;
    var out = [];
    COORD_HANDLES.forEach(function (h, i) {
      var node = d['c' + i]; if (!node) return;
      var p = normalize(node, true);   // bundle parents hold no stock of their own → availableForSale, not qty
      p.isPick3 = true;                // click goes straight to the bundle PDP, never the quick-add sheet
      p.isLaunch = false;              // standard card — no NEW LAUNCH pill
      p.colorName = coordColour(p.title);
      if (COORD_SIZES) p.displaySize = COORD_SIZES;
      p.rank = i;
      out.push(p);
    });
    coordProducts = out;
    cacheWriteRaw(COORD_CACHE_KEY, JSON.stringify({ t: Date.now(), p: coordProducts }));
    return productListKey(coordProducts) !== previousKey;
  }).catch(function (err) { console.error('SAW coord fetch', err); return false; });
}
  function fetchLaunch() {
    if (!ALL_CODES.length) { launchPool = []; return Promise.resolve(false); }
    try {
      var r = cacheReadRaw(LAUNCH_CACHE_KEY);
      if (r) { var o = JSON.parse(r); launchPool = o.p; if (Date.now() - o.t <= CACHE_TTL) return Promise.resolve(false); }
    } catch (e) {}
    var previousKey = productListKey(launchPool);
    var qStr = ALL_CODES.map(function (c) { return 'tag:' + c; }).join(' OR ');
    return gql('{ products(first: 250, sortKey: BEST_SELLING, query: "' + qStr + '") { edges { node {' + NODE_FIELDS + ' } } } }').then(function (j) {   /* 7 launch families now — 100 was tight */
      var edges = (j && j.data && j.data.products && j.data.products.edges) || [];
      launchPool = normalizeLaunchList(edges.map(function (e) { return e.node; }));
      cacheWriteRaw(LAUNCH_CACHE_KEY, JSON.stringify({ t: Date.now(), p: launchPool }));
      return productListKey(launchPool) !== previousKey;
    }).catch(function (err) { console.error('SAW launch fetch', err); if (launchPool === null) launchPool = []; return false; });
  }
  /* ── copy of snippets/saw-tabs-loader.liquid (2026-10-01) — re-sync here if that snippet changes ── */
  var SAWT_URL = C.sawt_url;
  var SAWT_TTL = 6 * 60 * 60 * 1000;
  var sawTabsRaw = null;
  var sawTabsExtra = { women: null, men: null };

  function sawtCacheGet(k) { try { return JSON.parse(localStorage.getItem(k) || 'null'); } catch (e) { return null; } }
  function sawtCacheSet(k, v) { try { localStorage.setItem(k, JSON.stringify({ t: Date.now(), p: v })); } catch (e) {} }

  /* Synchronous, for engines that paint from their own cache before any promise resolves — without
     it a repeat visitor sees the tabs half-empty for a frame while identical data comes back. */
  function sawTabsPrime() {
    var c = sawtCacheGet('saw_tabs_v1');
    if (c) sawTabsRaw = c.p;
    ['women', 'men'].forEach(function (g) {
      var x = sawtCacheGet('saw_tabx_v1_' + g);
      if (x) sawTabsExtra[g] = x.p;
    });
  }

  function sawTabsLoad() {
    var c = sawtCacheGet('saw_tabs_v1');
    if (c) { sawTabsRaw = c.p; if (Date.now() - c.t <= SAWT_TTL) return Promise.resolve(sawTabsRaw); }
    return fetch(SAWT_URL).then(function (r) { return r.json(); }).then(function (j) {
      sawTabsRaw = j; sawtCacheSet('saw_tabs_v1', j); return j;
    }).catch(function (e) {
      // A missing or broken file must leave the host on its old rules, not blank the block.
      console.error('SAW tabs', e); if (!sawTabsRaw) sawTabsRaw = {}; return sawTabsRaw;
    });
  }

  function sawtRank(list) { var m = {}; (list || []).forEach(function (h, i) { m[h] = i + 1; }); return m; }
  function sawTabsFor(g) {
    var t = sawTabsRaw || {};
    return { top: sawtRank((t.top || {})[g]), best: sawtRank((t.best || {})[g]), drop: sawtRank((t.drop || {})[g]) };
  }
  function sawTabsUsable(t) { return !!(Object.keys(t.top).length || Object.keys(t.best).length || Object.keys(t.drop).length); }

  /* Classified products the host's own pool does not contain. Every engine builds its pool
     best-selling-first, so the slow movers Top Rated wants and the broken-stock lines Price Drop
     wants are largely absent from it. `fields` is the host's own node field list, so the products
     that come back have the shape its cards expect. */
  function sawTabsTopUp(g, havePool, fields) {
    var t = sawTabsFor(g);
    if (!sawTabsUsable(t)) { sawTabsExtra[g] = []; return Promise.resolve(sawTabsExtra[g]); }
    var have = {};
    (havePool || []).forEach(function (p) { have[p.handle] = 1; });
    var miss = [];
    [t.top, t.best, t.drop].forEach(function (m) {
      Object.keys(m).forEach(function (h) { if (!have[h] && miss.indexOf(h) === -1) miss.push(h); });
    });
    if (!miss.length) { sawTabsExtra[g] = []; return Promise.resolve(sawTabsExtra[g]); }
    var K = 'saw_tabx_v1_' + g, cached = sawtCacheGet(K);
    if (cached) { sawTabsExtra[g] = cached.p; if (Date.now() - cached.t <= SAWT_TTL) return Promise.resolve(sawTabsExtra[g]); }
    var chunks = [];
    for (var i = 0; i < miss.length; i += 50) chunks.push(miss.slice(i, i + 50));
    return Promise.all(chunks.map(function (part) {
      var q = part.map(function (h) { return 'handle:' + h; }).join(' OR ');
      return gql('{ products(first: 50, query: ' + JSON.stringify(q) + ') { edges { node {' + fields + ' } } } }')
        .then(function (j) { return ((j && j.data && j.data.products && j.data.products.edges) || []).map(function (e) { return e.node; }); })
        .catch(function (e) { console.error('SAW tab products', e); return []; });
    })).then(function (parts) {
      sawTabsExtra[g] = normalizeList([].concat.apply([], parts));
      sawtCacheSet(K, sawTabsExtra[g]);
      return sawTabsExtra[g];
    });
  }

  /** The host's candidates that belong to one tab, in the file's order. */
  function sawTabsPick(cands, m) {
    return cands.filter(function (p) { return m[p.handle]; })
                .sort(function (a, b) { return m[a.handle] - m[b.handle]; });
  }

  /* Price Drop pool: one store-wide fetch of the curated gone-tags (All Linen's Almost Gone source) */
  var dropPool = null;
  var DROP_CACHE_KEY = 'ncl_drop_v1_' + DROP_TAGS.join('_');
  function fetchDrop() {
    if (!DROP_TAGS.length) { dropPool = []; return Promise.resolve(false); }
    try {
      var r = cacheReadRaw(DROP_CACHE_KEY);
      if (r) { var o = JSON.parse(r); dropPool = o.p; if (Date.now() - o.t <= CACHE_TTL) return Promise.resolve(false); }
    } catch (e) {}
    var previousKey = productListKey(dropPool);
    var qStr = DROP_TAGS.map(function (c) { return 'tag:' + c; }).join(' OR ');
    return gql('{ products(first: 250, query: "' + qStr + '") { edges { node {' + NODE_FIELDS + ' } } } }').then(function (j) {
      var edges = (j && j.data && j.data.products && j.data.products.edges) || [];
      dropPool = normalizeList(edges.map(function (e) { return e.node; }));
      cacheWriteRaw(DROP_CACHE_KEY, JSON.stringify({ t: Date.now(), p: dropPool }));
      return productListKey(dropPool) !== previousKey;
    }).catch(function (err) { console.error('SAW drop fetch', err); if (dropPool === null) dropPool = []; return false; });
  }

  var TOP_SRC_W = C.top_source_women;
  var TOP_SRC_M = C.top_source_men;
  var topPools = { women: null, men: null };
  /* speed 2026-10-15: pool size is a setting (Comfort Edit 60 ≈ 260 KB; 250 ≈ 1.1 MB of JSON parsed on the phone before first paint) */
  var TOP_POOL = Math.max(20, Math.min(250, parseInt(C.top_pool_size, 10) || 250));
  function fetchTop(only) {
    var jobs = [];
    [['women', TOP_SRC_W], ['men', TOP_SRC_M]].forEach(function (pr) {
      var g = pr[0], h = pr[1]; if (!h || (only && only.indexOf(g) === -1)) return;   // 2026-10-01: one gender up front, the other after load
      var K = 'saw_top_v1_' + h;
      try { var r = cacheReadRaw(K); if (r) { var o = JSON.parse(r); topPools[g] = o.p; if (Date.now() - o.t <= CACHE_TTL) return; } } catch (e) {}
      jobs.push(gql('{ collection(handle: "' + h + '") { products(first: ' + TOP_POOL + ', sortKey: BEST_SELLING) { edges { node {' + NODE_FIELDS + ' } } } } }').then(function (j) {
        var edges = (j && j.data && j.data.collection && j.data.collection.products.edges) || [];
        topPools[g] = normalizeList(edges.map(function (e) { return e.node; }));
        cacheWriteRaw(K, JSON.stringify({ t: Date.now(), p: topPools[g] }));
      }).catch(function (e) { console.error('SAW top fetch', e); }));
    });
    return Promise.all(jobs).then(function () { return false; });
  }
  function finishRender() {
    if (!categories.length) { gridEl.innerHTML = '<div class="saw-loading">No products found in collection.</div>'; return; }
    var prices = [];
    categories.forEach(function (c) { c.products.forEach(function (p) { prices.push(p.price); }); });
    if (prices.length) maxPriceLimit = Math.ceil(Math.max.apply(null, prices) / 100) * 100;
    filterState.maxPrice = maxPriceLimit;
    var minR = id('saw-price-min-range'), maxR = id('saw-price-max-range'), maxI = id('saw-price-max-input');
    if (minR) minR.max = maxPriceLimit;
    if (maxR) { maxR.max = maxPriceLimit; maxR.value = maxPriceLimit; }
    if (maxI) maxI.value = maxPriceLimit;
    if (window['_sawUpdateTrack_' + SID]) window['_sawUpdateTrack_' + SID]();
    renderShells();
    applyGroupVisibility();
    setTimeout(handleSticky, 100);
    setTimeout(syncSpy, 200);
  }

  function loadFresh(isBackground) {
    var myReq = reqSeq;                       // token for this fetch
    var raw = [];
    function page(after, size) {
      return gql(buildQuery(after, size)).then(function (j) {
        var coll = j && j.data && j.data.collection;
        if (!coll) return;
        var conn = coll.products;
        (conn.edges || []).forEach(function (e) { raw.push(e.node); });
        if (myReq !== reqSeq) return;         // gender changed mid-flight → drop this response
        if (conn.pageInfo && conn.pageInfo.hasNextPage && raw.length < MAX) return page(conn.pageInfo.endCursor, Math.min(250, MAX - raw.length));
      });
    }
    return page(null, Math.min(250, MAX)).then(function () {
      var prods = normalizeList(raw);
      if (!prods.length) return;
      writeCache(prods);                        // cache is keyed per collection, so this is still valid
      if (myReq !== reqSeq) return;             // …but don't paint another gender's products
      if (isBackground) return;                 // stale-while-revalidate: the next page load gets fresh data without moving this one
      return extrasReady.then(function (extrasChanged) {
        if (myReq !== reqSeq) return;
        fetchComplete = true;
        lastProds = prods;
        buildCategories(prods);
        finishRender();                         // one structural paint, after the complete catalogue + auxiliary pools
        if (extrasChanged) extrasReady = Promise.resolve(false);
      });
    }).catch(function (err) { console.error('SAW', err); });
  }

  /* ───────── gender (women / men) ───────── */
  function setGenderToggleUI() {
    qsa('.saw-gender-btn', root).forEach(function (b) { b.classList.toggle('is-active', b.getAttribute('data-gender') === currentGender); });
  }
  /* address bar follows the shopper (owner, 2026-10-01): tile → ?category=<tile slug>, gender → ?gender=…, so the URL is always a working deep link */
  function nclSetUrl(k, v) { try { var u = new URL(location.href); if (v) u.searchParams.set(k, v); else u.searchParams.delete(k); history.replaceState(history.state, '', u.pathname + u.search + u.hash); } catch (e) {} }
  function rememberGender(g) {
    nclSetUrl('gender', g === 'men' ? 'men' : 'women'); nclSetUrl('category', ''); try { localStorage.setItem('saw_gender_' + SID, g); } catch (e) {} }
  function readGender() { try { return localStorage.getItem('saw_gender_' + SID); } catch (e) { return null; } }
  function heroOffGenderDefault(templateSuffix, search) {
    try {
      if (templateSuffix !== 'gap-twill2') return null;
      var q = new URLSearchParams(search || '');
      var h = (q.get('hero') || '').toLowerCase(), l = (q.get('layout') || '').toLowerCase();
      return (h === 'off' || h === '0' || h === 'false' || l === 'classic' || l === 'gap-twill') ? 'men' : null;
    } catch (e) { return null; }
  }
  var WOMEN_ONLY = C.women_only;
  function decideInitialGender() {
    if (WOMEN_ONLY) return 'women';   // single-gender page: never show the chooser
    var u = (function () { var q = new URLSearchParams(window.location.search); return q.get('gender') || q.get('tab'); })();   // ?tab= kept in sync with the All Linen pages
    if (u) { u = u.toLowerCase().trim(); if (u === 'men' || u === 'male') return 'men'; if (u === 'women' || u === 'female') return 'women'; }
    var cg = urlCatGender(); if (cg) return cg;   // ?category= deep link → that family's gender, no popup
    var routeDefault = heroOffGenderDefault(TEMPLATE_SUFFIX, window.location.search); if (routeDefault) return routeDefault;
    var s = readGender(); if (s === 'men' || s === 'women') return s;
    return null;
  }
  var SKEL_CARD = '<div><div class="saw-skel-img"></div><div class="saw-skel-line"></div><div class="saw-skel-line short"></div></div>';
  var SKEL_ROWS = (function () {
    var row = '<div class="saw-cat saw-gt-zone"><div class="saw-skel-head"></div><div class="saw-gt-grid">' + SKEL_CARD + SKEL_CARD + SKEL_CARD + SKEL_CARD + '</div></div>';
    return row + row + row + row + row + row;
  })();
  var SKEL_TILES = (function () {
    var t = '<span class="saw-roundel saw-ctog saw-ctog-skel"><span class="saw-ctog-img"></span><span class="saw-skel-tile-lbl"></span></span>';
    return gthHeroKeep ? t + t + t + t : t + t + t + t + t;
  })();
  var reqSeq = 0;   // bumped on every gender switch — stale fetches check this before painting
  var lastProds = null;    // last normalized catalogue list — re-folded when the launch fetch lands
  var launchPool = null;   // normalized launch products (store-wide tag fetch, gender-agnostic); null until loaded
  var extrasReady = Promise.resolve(false);
  var fetchComplete = false;   // false while the foreground fetch is still paging → skeleton tiles pad the rail
  var PRE_KEEP = !!(roundelRow && roundelRow.getAttribute('data-pre'));   // Liquid prerender (women) still on screen
  function resetState() {
    reqSeq++;
    var isInitialReset = reqSeq === 1;
    allProducts = {}; categories = []; activeGroup = null;
    filterState = { size: null, colors: [], family: [], minPrice: 0, maxPrice: Infinity };
    maxPriceLimit = 5000; tempFilterSize = null; tempFilterColors = []; tempFilterFamily = []; tempFilterGroup = null;
    lastActiveSlug = null; manualLockUntil = 0;
    lastProds = null;   // stale-gender guard: the launch-fetch fold only repaints once this gender's list lands
    if (spyIO) { spyIO.disconnect(); spyIO = null; }
    if (PRE_KEEP && currentGender !== 'women') PRE_KEEP = false;
    if (!PRE_KEEP) {
      if (roundelRow) roundelRow.innerHTML = SKEL_TILES;
      if (gridEl && !isInitialReset) gridEl.innerHTML = SKEL_ROWS;
    }
    var emptyEl = document.getElementById('saw-empty-' + SID); if (emptyEl) emptyEl.style.display = 'none';
    setActiveToggle(); updateFilterLabel();
  }
  var warmOtherGender = function () {}, nclG0 = null;
  function loadGender(g, presetSize) {
    setGenderVars(g);
    if (nclG0 && currentGender !== nclG0 && topPools[currentGender] == null) warmOtherGender();   // switched before the deferred pool arrived
    try {   // All Linen contract: dual banner + friends listen for saw:gender with capitalized gender
      var gCap = currentGender === 'men' ? 'Men' : 'Women';
      window.__sawGender = gCap;
      document.documentElement.classList.toggle('ncl-g-men', currentGender === 'men');   // MEN: no toggle row (owner, 2026-10-01)
      document.dispatchEvent(new CustomEvent('saw:gender', { detail: { gender: gCap } }));
    } catch (e) {}
    setGenderToggleUI();
    resetState();
    mountHero();
    if (presetSize) { filterState.size = presetSize; updateFilterLabel(); }
    if (!COLLECTION) { lastProds = []; fetchComplete = true; buildCategories([]); finishRender(); return; }   // no source collection → launch rows only
    var cached = readCache();
    if (cached && cached.length) {
      var cachedReq = reqSeq;
      var paintCached = function () {
        if (cachedReq !== reqSeq) return;
        fetchComplete = true; lastProds = cached; buildCategories(cached); finishRender(); loadFresh(true);
      };
      if (launchPool !== null) paintCached(); else extrasReady.then(paintCached);
    }
    else { fetchComplete = false; loadFresh(false); }
  }
  function bindGenderToggle() {
    qsa('.saw-gender-btn', root).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var g = btn.getAttribute('data-gender');
        if (g === currentGender) return;
        rememberGender(g); loadGender(g);   // no scroll-to-top — stay where the user is
      });
    });
  }
  var gpop = id('saw-gpop');
  var gpopGender = null, gpopSize = null;
  function showPopup() { if (gpop) { gpop.classList.add('is-visible'); lockBody(); } }
  function hidePopup() { if (gpop) { gpop.classList.remove('is-visible'); unlockBody(); } }
  function bindPopup() {
    if (!gpop) return;
    var err = id('saw-gpop-err');
    qsa('.saw-gpop-opt', gpop).forEach(function (btn) {
      btn.addEventListener('click', function () {
        gpopGender = btn.getAttribute('data-gpop-gender');
        qsa('.saw-gpop-opt', gpop).forEach(function (b) { b.classList.toggle('is-active', b === btn); });
        if (err) err.textContent = '';
      });
    });
    qsa('.saw-gpop-size', gpop).forEach(function (btn) {
      btn.addEventListener('click', function () {
        gpopSize = btn.getAttribute('data-gpop-size');
        qsa('.saw-gpop-size', gpop).forEach(function (b) { b.classList.toggle('is-active', b === btn); });
        if (err) err.textContent = '';
      });
    });
    var go = id('saw-gpop-go');
    if (go) go.addEventListener('click', function () {
      if (!gpopGender) { if (err) err.textContent = 'Please select a gender to continue'; return; }
      // 2026-10-01: popup is gender-only — no size required (size via the floating SIZE chip)
      rememberGender(gpopGender); hidePopup();
      if (gpopGender === currentGender && Object.keys(allProducts).length) {
        // prefetched while the popup was open — just apply the picked size
        if (gpopSize) { filterState.size = gpopSize; updateFfSizeBtn(); updateFilterLabel(); applyGroupVisibility(); }
      } else {
        loadGender(gpopGender, gpopSize);
      }
    });
  }

  function gbwCopy(btn) {
    var code = btn.getAttribute('data-code'); if (!code) return;
    function done() {
      if (!btn.getAttribute('data-label')) btn.setAttribute('data-label', btn.textContent);
      btn.textContent = 'Copied!'; btn.classList.add('copied');
      setTimeout(function () { btn.textContent = btn.getAttribute('data-label'); btn.classList.remove('copied'); }, 1500);
    }
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code).then(done).catch(done);
    else { var ta = document.createElement('textarea'); ta.value = code; document.body.appendChild(ta); ta.select(); try { document.execCommand('copy'); } catch (e) {} document.body.removeChild(ta); done(); }
  }
  function startGuaranteeRotator() {
    var el = id('saw-guarantee-text'); if (!el) return;
    var msgs = ['Get Extra Discount On Upi Orders', 'Apply coupon at checkout for a risk-free trial.'];
    var i = 0;
    if (window['sawGtInt_' + SID]) clearInterval(window['sawGtInt_' + SID]);
    window['sawGtInt_' + SID] = setInterval(function () {
      i = (i + 1) % msgs.length;
      el.style.opacity = '1';
      el.textContent = msgs[i];   /* instant swap — no opacity fade so old + new text never composite/ghost on WebKit */
    }, 3000);
  }

  /* floating bar stays hidden until the Happening Now zone scrolls into view (flowy behaviour) */
  var gtFfBarEl = document.getElementById('saw-ffilter-' + SID);   // NOT named ffBar — that's the engine's dropdown helper fn
  function updateFfReveal() {
    /* 2026-08-10: bar is page-wide now — visible top to bottom (was: hidden until Happening Now scrolled into view) */
    if (!gtFfBarEl) return;
    gtFfBarEl.classList.remove('is-ffhidden');
  }
  window.addEventListener('scroll', updateFfReveal, { passive: true });
  window.addEventListener('resize', updateFfReveal);
  /* ── EARLY ACCESS repeating countdown: EA_HOURS-hour cycles from ea_start to ea_end (IST), then everything hides ── */
  function parseIST(s) {
    s = (s || '').trim(); if (!s) return null;
    if (s.length === 10) s += 'T12:00';
    if (s.indexOf('T') === -1) s = s.replace(' ', 'T');
    if (s.length === 16) s += ':00';
    if (!/[+Zz]/.test(s.slice(10))) s += '+05:30';
    var d = new Date(s); return isNaN(d.getTime()) ? null : d;
  }
  var EA_START = parseIST(C.ea_start);
  var EA_END   = parseIST(C.ea_end);
  var EA_MS    = (parseInt(C.ea_hours, 10) || 48) * 3600000;
  var EA_LIVE_LABEL = C.count_text || 'OFFER ENDS IN';
  var EA_SUB = C.ea_sub || 'Offer refreshes every 48 hours';
  function eaState() {
    if (!EA_START || !EA_END) return { phase: 'off' };
    var now = Date.now();
    if (now >= EA_END.getTime()) return { phase: 'over' };
    if (now < EA_START.getTime()) return { phase: 'pre', end: EA_START.getTime() };
    var end = EA_START.getTime() + (Math.floor((now - EA_START.getTime()) / EA_MS) + 1) * EA_MS;
    if (end > EA_END.getTime()) end = EA_END.getTime();
    return { phase: 'live', end: end };
  }
  function fmtLeft(ms) {
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    var h = Math.floor(ms / 3600000), mi = Math.floor(ms / 60000) % 60, s = Math.floor(ms / 1000) % 60;
    return (h > 0 ? h + 'h ' : '') + pad(mi) + 'm ' + pad(s) + 's';
  }
  function eaSegsHtml(ms) {   // segmented D / H / M / S blocks (each unit gets its own translucent chip)
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    var d = Math.floor(ms / 86400000), h = Math.floor(ms / 3600000) % 24, mi = Math.floor(ms / 60000) % 60, s = Math.floor(ms / 1000) % 60;
    var parts = [];
    if (d > 0) parts.push([d, 'D']);
    parts.push([pad(h), 'H'], [pad(mi), 'M'], [pad(s), 'S']);
    return parts.map(function (p) { return '<span class="saw-ea-seg"><b>' + p[0] + '</b><i>' + p[1] + '</i></span>'; }).join('');
  }
  function startPreCount() {
    var bar = id('saw-precount'), tEl = id('saw-precount-t'), lEl = id('saw-precount-l');
    if (!bar || !tEl) return;
    function tick() {
      var st = eaState();
      if (st.phase === 'off' || st.phase === 'over') { bar.hidden = true; if (window['sawPreCnt_' + SID]) clearInterval(window['sawPreCnt_' + SID]); return; }
      if (lEl) lEl.textContent = st.phase === 'pre' ? 'EARLY ACCESS STARTS IN' : EA_LIVE_LABEL;
      tEl.innerHTML = eaSegsHtml(st.end - Date.now());
      bar.hidden = false;
    }
    if (window['sawPreCnt_' + SID]) clearInterval(window['sawPreCnt_' + SID]);
    tick(); window['sawPreCnt_' + SID] = setInterval(tick, 1000);
  }
  /* overview banner, per product: launch → EA countdown (hides after ea_end); everything else → BUY 3 GET 1. */
  function qaBannerSync() {
    var addB = id('saw-qa-add');                                // the qa overlay lives OUTSIDE .saw-root — resolve via section-suffixed id
    var btnRow = addB && addB.closest('.saw-btn-row');
    if (!btnRow) return;
    var kwb = btnRow.parentElement.querySelector('.kw-b3g1');
    if (window['sawQaEa_' + SID]) { clearInterval(window['sawQaEa_' + SID]); window['sawQaEa_' + SID] = null; }
    if (!kwb) { btnRow.insertAdjacentHTML('afterend', '<div class="kw-b3g1" data-offer-mode="attr"></div>'); kwb = btnRow.parentElement.querySelector('.kw-b3g1'); }
    if (!kwb) return;
    if (qaHideOffer) { kwb.style.display = 'none'; return; }
    kwb.setAttribute('data-offer-mode', 'attr');
    if (qaCurrentProduct && qaCurrentProduct.isLaunch) {
      var paint = function () {
        var st = eaState();
        if (st.phase === 'off' || st.phase === 'over') {
          kwb.style.display = 'none';
          if (window['sawQaEa_' + SID]) clearInterval(window['sawQaEa_' + SID]);
          return;
        }
        kwb.style.display = '';
        var top = st.phase === 'pre' ? 'EARLY ACCESS STARTS IN' : EA_LIVE_LABEL;
        var t = kwb.querySelector('[data-ea-t]');
        if (!t || kwb.getAttribute('data-ea-top') !== top) {
          kwb.setAttribute('data-ea-top', top);
          kwb.innerHTML = '<div class="kw-b3g1-top">' + top + '</div><div class="kw-b3g1-main"><span data-ea-t role="timer" aria-live="off" aria-atomic="true">--</span></div><div class="kw-b3g1-sub"><span></span><b>' + EA_SUB + '</b><span></span></div>';
          t = kwb.querySelector('[data-ea-t]');
        }
        if (t) t.innerHTML = eaSegsHtml(st.end - Date.now());
      };
      paint();
      window['sawQaEa_' + SID] = setInterval(paint, 1000);
    } else {
      kwb.style.display = '';
      kwb.removeAttribute('data-ea-top');
      kwb.innerHTML = '<div class="kw-b3g1-top">You Just Got an <em>Upgrade!</em></div><div class="kw-b3g1-main">BUY 3, GET 1 <em>FREE</em></div><div class="kw-b3g1-sub"><span></span><b>Automatically Applied at Checkout.</b><span></span></div>';
    }
  }
  function init() {
    sawTabsPrime();
    bindToggle();
    bindGenderToggle();
    bindPopup();
    setupSlider();
    startGuaranteeRotator();
    startPreCount();
    fetchPick3();   // optional injected cards hydrate/cache without blocking the critical roundel rail
    /* speed 2026-10-01: only the opening gender's Top Rated pool blocks the first paint; the other one (≈20–60 KB of
       product data) loads after the page has loaded, or at once if the shopper switches before that */
    var g0 = decideInitialGender() || 'women', g1 = g0 === 'men' ? 'women' : 'men', otherP = null; nclG0 = g0;
    /* speed 2026-10-15: the saw-tabs top-up (another 50–200 products) is not read by this page's rows — it only warms the
       shared saw_tabx cache — so it runs after load instead of holding the first paint */
    var tabsReady = Promise.all([sawTabsLoad(), fetchTop([g0])]);
    var topUpLater = function () { setTimeout(function () { tabsReady.then(function () { return sawTabsTopUp(g0, topPools[g0], NODE_FIELDS); }).catch(function () {}); }, 3000); };
    if (document.readyState === 'complete') topUpLater(); else window.addEventListener('load', topUpLater, { once: true });
    warmOtherGender = function () {
      if (otherP) return otherP;
      otherP = tabsReady.then(function () { return fetchTop([g1]); }).then(function () { return sawTabsTopUp(g1, topPools[g1], NODE_FIELDS); })
        .then(function () { if (currentGender === g1) loadGender(g1); }).catch(function () {});
      return otherP;
    };
    var warmLater = function () { setTimeout(warmOtherGender, 2500); };
    if (document.readyState === 'complete') warmLater(); else window.addEventListener('load', warmLater, { once: true });
    extrasReady = Promise.all([fetchLaunch(), tabsReady, fetchCoords()]).then(function (a) { return a[0] || a[2]; });
    tabsReady.then(function () { if (!sawTabsUsable(sawTabsFor(currentGender))) fetchDrop(); });   // Price Drop fallback only when the tabs classification is missing
    // (strip relocation removed 2026-07-30 — the header now carries the trust strip site-wide)
    var g = decideInitialGender();
    if (g) { loadGender(g); }
    else {
      // First visit: fetch + paint the default gender BEHIND the popup (campaign3 pattern), so the
      // page is never a black overlay over nothing and the answer applies to already-loaded data.
      var preG = gpop && gpop.querySelector('.saw-gpop-opt.is-active');
      var preS = gpop && gpop.querySelector('.saw-gpop-size.is-active');
      gpopGender = preG ? preG.getAttribute('data-gpop-gender') : 'women';   // matches the prefetched gender
      if (preS) gpopSize = preS.getAttribute('data-gpop-size');
      showPopup();
      loadGender('women');
    }
  }
  init();
})();
